import Configuration from "../../../../config/configuration";
import Temperature from "../../../../assets/svg/DesignIcons/temperature";
import CompactandElegantDesign from "../../../../assets/svg/DesignIcons/compactanelegantdesign";
import EnergySavingIcon from "../../../../assets/svg/DesignIcons/Energysavingicon";
import ComfortIcon from "../../../../assets/svg/DesignIcons/Comforticon";
import ConvenienceIcon from "../../../../assets/svg/DesignIcons/Convenienceicon";
import CompatabilitiyIcon from "../../../../assets/svg/DesignIcons/Compatabilityicon";
import SecurityIcon from "../../../../assets/svg/DesignIcons/Securityicon";
import InnovationIcon from "../../../../assets/svg/DesignIcons/Innovationicon";

import RugEdge_v3000_blue from '../../../../assets/image/Products/RugEdge_v3000/RugEdge_v3000_blue.webp'
import RugEdge_v3000HomePage from '../../../../assets/image/Products/RugEdge_v3000/RugEdge_v3000HomePage.webp'
import RugEdge_v3000catalog1 from '../../../../assets/image/Products/RugEdge_v3000/ProductCatalog/RugEdge_v3000_Catalog1.webp'
import RugEdge_v3000catalog2 from '../../../../assets/image/Products/RugEdge_v3000/ProductCatalog/RugEdge_v3000_Catalog2.webp'
import RugEdge_v3000catalog3 from '../../../../assets/image/Products/RugEdge_v3000/ProductCatalog/RugEdge_v3000_Catalog3.webp'
import RugEdge_v3000catalog4 from '../../../../assets/image/Products/RugEdge_v3000/ProductCatalog/RugEdge_v3000_Catalog4.webp'
import RugEdge_v3000Features from '../../../../assets/image/Products/RugEdge_v3000/RugEdge_v3000_KeyFeatures.webp'
import RugEdge_v3000FeaturesMobile from '../../../../assets/image/Products/RugEdge_v3000/RugEdge_v3000_KeyFeaturesMobile.webp'
import RugEdge_v3000_Solutions from '../../../../assets/image/Products/RugEdge_v3000/RugEdge_v3000_Solutions.webp'
import RugEdge_v3000_SolutionsMobile from '../../../../assets/image/Products/RugEdge_v3000/RugEdge_v3000_SolutionsMobile.webp'

import RugEdge_r8000HomePage from '../../../../assets/image/Products/RugEdge_r8000/RugEdge_r8000_Homepage.webp'
import RugEdge_r8000_black from '../../../../assets/image/Products/RugEdge_r8000/RugEdge_r8000BlackColor.webp'
import RugEdge_r8000catalog1 from '../../../../assets/image/Products/RugEdge_r8000/ProductCatalog/RugEdge_r8000_Catalog1.webp'
import RugEdge_r8000catalog2 from '../../../../assets/image/Products/RugEdge_r8000/ProductCatalog/RugEdge_r8000_Catalog2.webp'
import RugEdge_r8000catalog3 from '../../../../assets/image/Products/RugEdge_r8000/ProductCatalog/RugEdge_r8000_Catalog3.webp'
import RugEdge_r8000catalog4 from '../../../../assets/image/Products/RugEdge_r8000/ProductCatalog/RugEdge_r8000_Catalog4.webp'
import RugEdge_r8000Features from '../../../../assets/image/Products/RugEdge_r8000/RugEdge_r8000_KeyFeatures.webp'
import RugEdge_r8000_Solutions from '../../../../assets/image/Products/RugEdge_r8000/RugEdge_r8000_Solutions.webp'
import RugEdge_r8000_SolutionsMobile from '../../../../assets/image/Products/RugEdge_r8000/RugEdge_r8000_SolutionsMobile.webp'

const Rohs = `${Configuration?.S3_URL}TrustedandCompilances/rohs.webp`;
const Ce = `${Configuration?.S3_URL}TrustedandCompilances/celogo.webp`;
const Cepassed = `${Configuration?.S3_URL}TrustedandCompilances/930ce.webp`;

const SzephyrHomePage = `${Configuration?.S3_URL}Products/AltSzephyr/Szephr_home_page.webp`;
const SzephyrMobileHomePage = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrHomeMobile.webp`;
const SzephyrMobileApplicationImage = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrMobileApplication.webp`;
const SzephyrInstallationstep1 = `${Configuration?.S3_URL}Products/AltSzephyr/InstallationGuide/Szephyr_installation_1.webp`;
const SzephyrInstallationstep2 = `${Configuration?.S3_URL}Products/AltSzephyr/InstallationGuide/Szephyr_installation_2.webp`;
const SzephyrInstallationstep3 = `${Configuration?.S3_URL}Products/AltSzephyr/InstallationGuide/Szephyr_installation_3.webp`;
const SzephyrInstallationstep1Mobile = `${Configuration?.S3_URL}Products/AltSzephyr/InstallationGuide/Szephyr_installation_mobile_1.webp`;
const SzephyrInstallationstep2Mobile = `${Configuration?.S3_URL}Products/AltSzephyr/InstallationGuide/Szephyr_installation_mobile_2.webp`;
const SzephyrInstallationstep3Mobile = `${Configuration?.S3_URL}Products/AltSzephyr/InstallationGuide/Szephyr_installation_mobile_3.webp`;
const SzephyrWhite = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrColors/szephyr-white.webp`;
const SzephyrBlue = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrColors/szephyr-blue.webp`;
const SzephyrGreen = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrColors/szephyr-green.webp`;
const SzephyrGrey = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrColors/szephyr-grey.webp`;
const SzephyrMobileAppImage = `${Configuration?.S3_URL}Products/AltSzephyr/Szephr-mobile-app.webp`;
const SzephyrWebApplication1 = `${Configuration?.S3_URL}Products/AltSzephyr/webapplicationimg1.webp`;
const SzephyrWebApplication2 = `${Configuration?.S3_URL}Products/AltSzephyr/webapplicationimg2.webp`;
const SzephyrIndustrialAutomation = `${Configuration?.S3_URL}Products/AltSzephyr/WebAppDiff/Industrialautomation.webp`;
const SzephyrHomeAutomation = `${Configuration?.S3_URL}Products/AltSzephyr/WebAppDiff/Homeautomation.webp`;
const SzephyrIndustrialWebApp = `${Configuration?.S3_URL}Products/AltSzephyr/WebAppDiff/WebApp.webp`;

const SmazerHomePage = `${Configuration?.S3_URL}Products/AltSmazer/SmazerHome.webp`;
const SmazerMobileHomePage = `${Configuration?.S3_URL}Products/AltSmazer/SmazerHomeMobile.webp`;
const SmazerInstallationstep1 = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallation1.webp`;
const SmazerInstallationstep2 = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallation2.webp`;
const SmazerInstallationstep3 = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallation3.webp`;
const SmazerInstallationstep4 = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallation4.webp`;
const SmazerMobileAppImage = `${Configuration?.S3_URL}Products/AltSmazer/SmazerApplication.webp`;
const SmazerWhite = `${Configuration?.S3_URL}Products/AltSmazer/SmazerColors/Smazer_white.webp`;
const SmazerBlue = `${Configuration?.S3_URL}Products/AltSmazer/SmazerColors/Smazer_blue.webp`;
const SmazerGreen = `${Configuration?.S3_URL}Products/AltSmazer/SmazerColors/Smazer_green.webp`;
const SmazerGrey = `${Configuration?.S3_URL}Products/AltSmazer/SmazerColors/Smazer_grey.webp`;
const SzephyrKeyFeatures = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrFeatures.webp`;
const SmazerKeyFeatures = `${Configuration?.S3_URL}Products/AltSmazer/SmazerKeyFeatures.webp`;
const SmazerProductFeatureMobile = `${Configuration?.S3_URL}Products/AltSmazer/SmazerFeatures.webp`;
const SmazerWebApplication1 = `${Configuration?.S3_URL}Products/AltSmazer/smazerwebapplication1.webp`;
const SmazerWebApplication2 = `${Configuration?.S3_URL}Products/AltSmazer/smazerwebapplication2.webp`;
const SmazerInstallationstep1Mobile = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallationmobile1.webp`;
const SmazerInstallationstep2Mobile = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallationmobile2.webp`;
const SmazerInstallationstep3Mobile = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallationmobile3.webp`;
const SmazerInstallationstep4Mobile = `${Configuration?.S3_URL}Products/AltSmazer/InstallationGuide/Smazerinstallationmobile4.webp`;
const SmazerMobileApplication = `${Configuration?.S3_URL}Products/AltSmazer/Smazermobilepplication.webp`;
const SmazerIndustrialAutomation = `${Configuration?.S3_URL}Products/AltSmazer/WebAppDiff/SmazerAutomation.webp`;
const SmazerHomeAutomation = `${Configuration?.S3_URL}Products/AltSmazer/WebAppDiff/SmazerHomeAutomation.webp`;
const SmazerIndustrialWebApp = `${Configuration?.S3_URL}Products/AltSmazer/WebAppDiff/SmazerWebApp.webp`;

const SmampMaxHomePage = `${Configuration?.S3_URL}Products/AltSmampMax/Smampmax_home_page.webp`;
const SmampMaxMobileHomePage = `${Configuration?.S3_URL}Products/AltSmampMax/SmampMaxHomeMobile.webp`;
const SmampMaxInstallationstep1 = `${Configuration?.S3_URL}Products/AltSmampMax/InstallationGuide/Smampmax_installation_1.webp`;
const SmampMaxInstallationstep2 = `${Configuration?.S3_URL}Products/AltSmampMax/InstallationGuide/Smampmax_installation_2.webp`;
const SmampMaxInstallationstep3 = `${Configuration?.S3_URL}Products/AltSmampMax/InstallationGuide/Smampmax_installation_3.webp`;
const SmampMaxMobileAppImage = `${Configuration?.S3_URL}Products/AltSmampMax/Smampmax-mobile-app.webp`;
const SmampMaxKeyFeatures = `${Configuration?.S3_URL}Products/AltSmampMax/SmamMaxFeatures.webp`;
const SmampMaxWhite = `${Configuration?.S3_URL}Products/AltSmampMax/SmampMaxColors/Smampmaxwhite.webp`;
const SmampMaxBlue = `${Configuration?.S3_URL}Products/AltSmampMax/SmampMaxColors/Smampmaxblue.webp`;
const SmampMaxGreen = `${Configuration?.S3_URL}Products/AltSmampMax/SmampMaxColors/Smampmaxgreen.webp`;
const SmampMaxGrey = `${Configuration?.S3_URL}Products/AltSmampMax/SmampMaxColors/Smampmaxgrey.webp`;
const SmampMaxMobileApplication = `${Configuration?.S3_URL}Products/AltSmampMax/smampmaxmobileapplication.webp`;
const SmampMaxWebApplication1 = `${Configuration?.S3_URL}Products/AltSmampMax/smampmaxwebapplication1.webp`;
const SmampMaxWebApplication2 = `${Configuration?.S3_URL}Products/AltSmampMax/smampmaxwebapplication2.webp`;
const SzephyrProductFeatures = `${Configuration?.S3_URL}Products/AltSzephyr/SzephyrMobile.webp`;
const SmampMaxProductFeaturesMobile = `${Configuration?.S3_URL}Products/AltSmampMax/SmampMaxMobile.webp`;
const SmampMaxInstallationstep1Mobile = `${Configuration?.S3_URL}Products/AltSmampMax/InstallationGuide/Smampmax_installation_mobile_1.webp`;
const SmampMaxInstallationstep2Mobile = `${Configuration?.S3_URL}Products/AltSmampMax/InstallationGuide/Smampmax_installation_mobile_2.webp`;
const SmampMaxInstallationstep3Mobile = `${Configuration?.S3_URL}Products/AltSmampMax/InstallationGuide/Smampmax_installation_mobile_3.webp`;

const SmartPanelKeyFeatures = `${Configuration?.S3_URL}Products/SmartPanel/SmartPanelKeyFeatures.webp`;
const SmampMaxIndustrialAutomation = `${Configuration?.S3_URL}Products/AltSmampMax/WebAppDiff/SmampMaxIndustrialAutomation.webp`;
const SmampMaxHomeAutomation = `${Configuration?.S3_URL}Products/AltSmampMax/WebAppDiff/SmampMaxHomeAutomation.webp`;
const SmampMaxIndustrialWebApp = `${Configuration?.S3_URL}Products/AltSmampMax/WebAppDiff/SmampMaxWebApp.webp`;

const Smartpanelcatalog1 = `${Configuration?.S3_URL}Products/SmartPanel/ProductCatalog/Smarrtpanelcatalog1.webp`;
const Smartpanelcatalog2 = `${Configuration?.S3_URL}Products/SmartPanel/ProductCatalog/Smarrtpanelcatalog2.webp`;
const Smartpanelcatalog3 = `${Configuration?.S3_URL}Products/SmartPanel/ProductCatalog/Smarrtpanelcatalog3.webp`;
const Smartpanelcatalog4 = `${Configuration?.S3_URL}Products/SmartPanel/ProductCatalog/Smarrtpanelcatalog4.webp`;
const Smartpanelcatalog5 = `${Configuration?.S3_URL}Products/SmartPanel/ProductCatalog/Smarrtpanelcatalog5.webp`;
const Smartpanelcatalog6 = `${Configuration?.S3_URL}Products/SmartPanel/ProductCatalog/Smarrtpanelcatalog6.webp`;
const SmartPanelWhite = `${Configuration?.S3_URL}Products/SmartPanel/Group 1410085700.png`;
const SmartPanelGrey = `${Configuration?.S3_URL}Products/SmartPanel/Group 1410085698.png`;
const Smartpanelinstallationguide1 = `${Configuration?.S3_URL}Products/SmartPanel/Installationguide/Smartpanelinstallation1.webp`;
const Smartpanelinstallationguide2 = `${Configuration?.S3_URL}Products/SmartPanel/Installationguide/Smartpanelinstallation2.webp`;
const Smartpanelinstallationguide3 = `${Configuration?.S3_URL}Products/SmartPanel/Installationguide/Smartpanelinstallation3.webp`;
const Smartpanelinstallationguidemobile1 = `${Configuration?.S3_URL}Products/SmartPanel/Installationguide/SmartpanelinstallationMobile1.webp`;
const Smartpanelinstallationguidemobile2 = `${Configuration?.S3_URL}Products/SmartPanel/Installationguide/SmartpanelinstallationMobile2.webp`;
const Smartpanelinstallationguidemobile3 = `${Configuration?.S3_URL}Products/SmartPanel/Installationguide/SmartpanelinstallationMobile3.webp`;
const SmartpanelHomePage = `${Configuration?.S3_URL}Products/SmartPanel/SmartpanelHomepage.webp`;
const SmartPanelWebApplication1 = `${Configuration?.S3_URL}Products/SmartPanel/SmartpanelWebapp1.webp`;
const SmartPanelWebApplication2 = `${Configuration?.S3_URL}Products/SmartPanel/SmartpanelWebapp2.webp`;
const SmartPanelFeatureMobile = `${Configuration?.S3_URL}Products/SmartPanel/SmartPanelMobile.webp`;
const SmartpanelMobileHomePage = `${Configuration?.S3_URL}Products/SmartPanel/SmartpanelHomeMobile.webp`;


const EthernetRingKeyFeatures = `${Configuration?.S3_URL}Products/Ethernetring/EthernetKeyFeatures.webp`;
const EthernetHomePage = `${Configuration?.S3_URL}Products/Ethernetring/EthernetHome.webp`;
const EthernetWhite = `${Configuration?.S3_URL}Products/Ethernetring/EthernetWhite.webp`;
const Ethernetcatalog1 = `${Configuration?.S3_URL}Products/Ethernetring/ProductCatalog/Ethernetproductcatalog1.webp`;
const Ethernetcatalog2 = `${Configuration?.S3_URL}Products/Ethernetring/ProductCatalog/Ethernetproductcatalog2.webp`;
const Ethernetcatalog3 = `${Configuration?.S3_URL}Products/Ethernetring/ProductCatalog/Ethernetproductcatalog3.webp`;
const Ethernetcatalog4 = `${Configuration?.S3_URL}Products/Ethernetring/ProductCatalog/Ethernetproductcatalog4.webp`;
const Ethernetfeaturesmobile = `${Configuration?.S3_URL}Products/Ethernetring/Ethernetringmobile.webp`;

const SerialToRedundantHomePage = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/SerialfiberHomePage.webp`;
const SerialToRedundantKeyFeatures = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/SerialfiberKeyFeatures.webp`;
const SerialToRedundantKeyGrey = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/SerialfiberGrey.webp`;
const SerialToRedundantfeaturesmobile = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/SrfxFeatureMobile.webp`;

const Srfxcatalog1 = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/ProductCatalog/Srfxcatalog1.webp`;
const Srfxcatalog2 = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/ProductCatalog/Srfxcatalog2.webp`;
const Srfxcatalog3 = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/ProductCatalog/Srfxcatalog3.webp`;
const Srfxcatalog4 = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/ProductCatalog/Srfxcatalog4.webp`;
const Srfxcatalog5 = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/ProductCatalog/Srfxcatalog5.webp`;
const Srfxcatalog6 = `${Configuration?.S3_URL}Products/Serialtoredundantfibre/ProductCatalog/Srfxcatalog6.webp`;

const UhfRadioModemHome = `${Configuration?.S3_URL}Products/UhfRadioModem/UhfHome.webp`;
const UhfRadioModemHomeMobile = `${Configuration?.S3_URL}Products/UhfRadioModem/UHFKeyFeaturesMobile.webp`;
const UhfRadioModemKeyFeatures = `${Configuration?.S3_URL}Products/UhfRadioModem/UhfKeyFeatures.webp`;
const UhfRadioModemGrey = `${Configuration?.S3_URL}Products/UhfRadioModem/UhfGrey.webp`;
const Uhfcatalog1 = `${Configuration?.S3_URL}Products/UhfRadioModem/ProductCatalog/UHFProductCatalog1.webp`;
const Uhfcatalog2 = `${Configuration?.S3_URL}Products/UhfRadioModem/ProductCatalog/UHFProductCatalog2.webp`;
const Uhfcatalog3 = `${Configuration?.S3_URL}Products/UhfRadioModem/ProductCatalog/UHFProductCatalog3.webp`;
const Uhfcatalog4 = `${Configuration?.S3_URL}Products/UhfRadioModem/ProductCatalog/UHFProductCatalog4.webp`;
const Uhfcatalog5 = `${Configuration?.S3_URL}Products/UhfRadioModem/ProductCatalog/UHFProductCatalog5.webp`;
const Uhfcatalog6 = `${Configuration?.S3_URL}Products/UhfRadioModem/ProductCatalog/UHFProductCatalog6.webp`;
const UHFfeaturesmobile = `${Configuration?.S3_URL}Products/UhfRadioModem/UHFKeyFeaturesMobile.webp`;

const EmbeddedPcHome = `${Configuration?.S3_URL}Products/Embeddedpc/EmbeddedpcHome.webp`;
const EmbeddedPcKeyFeatures = `${Configuration?.S3_URL}Products/Embeddedpc/EmbeddedpcKeyFeatures.webp`;
const EmbeddedpcGrey = `${Configuration?.S3_URL}Products/Embeddedpc/EmbeddedpcGrey.webp`;
const Embeddedpccatalog1 = `${Configuration?.S3_URL}Products/Embeddedpc/ProductCatalog/ProductCatalog1.webp`;
const Embeddedpccatalog2 = `${Configuration?.S3_URL}Products/Embeddedpc/ProductCatalog/ProductCatalog2.webp`;
const Embeddedpccatalog3 = `${Configuration?.S3_URL}Products/Embeddedpc/ProductCatalog/ProductCatalog3.webp`;
const Embeddedpccatalog4 = `${Configuration?.S3_URL}Products/Embeddedpc/ProductCatalog/ProductCatalog4.webp`;
const Embeddedpccatalog5 = `${Configuration?.S3_URL}Products/Embeddedpc/ProductCatalog/ProductCatalog5.webp`;
const Embeddedpccatalog6 = `${Configuration?.S3_URL}Products/Embeddedpc/ProductCatalog/ProductCatalog6.webp`;
const EmbeddedPcKeyFeaturesMobile = `${Configuration?.S3_URL}Products/Embeddedpc/EmbeddedpcKeyFeaturesMobile.webp`;

const MiniaturemscsHome = `${Configuration?.S3_URL}Products/Miniaturemscs/MiniaturemscsHome.webp`;
const MiniaturemscsKeyFeatures = `${Configuration?.S3_URL}Products/Miniaturemscs/MiniaturemscsKeyFeatures.webp`;
const MiniaturemscsKeyFeaturesMobile = `${Configuration?.S3_URL}Products/Miniaturemscs/MiniaturemscsKeyFeaturesMobile.webp`;
const MiniaturemscsGrey = `${Configuration?.S3_URL}Products/Miniaturemscs/MiniaturemscsGrey.webp`;

const VidyurakshaKeyFeatures = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/Vidhyuraksha_2.0_key_features.webp`;
const VidyurakshaKeyFeaturesMobile = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/Vidhyuraksha_2.0_key_features_mobile.webp`;
const VidyurakshaKeyHome = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/Vidhyuraksha_2.0.webp`;
const Vidhyurakshacatalog1 = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/ProductCatalog/VidyuRakshaCatalog1.webp`;
const Vidhyurakshacatalog2 = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/ProductCatalog/VidyuRakshaCatalog2.webp`;
const Vidhyurakshacatalog3 = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/ProductCatalog/VidyuRakshaCatalog3.webp`;
const Vidhyurakshacatalog4 = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/ProductCatalog/VidyuRakshaCatalog4.webp`;
const VidhyurakshaGrey = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/VidhyurakshaGrey.webp`;
const VidhyurakshaWebApplication1 = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/WebApplication/WebApplication.webp`;
const VidhyurakshaWebApplication2 = `${Configuration?.S3_URL}Products/Vidhyuraksha_2.0/WebApplication/WebApplicationDashboard.webp`;


const WaterQulaityBoardKeyFeatures = `${Configuration?.S3_URL}Products/WaterQualityBoard/WaterQualityBoardKeyFeatures.webp`;
const WaterQulaityBoardHome = `${Configuration?.S3_URL}Products/WaterQualityBoard/WaterQualityBoardHome.webp`;
const WaterQulaityBoardKeyFeaturesMobile = `${Configuration?.S3_URL}Products/WaterQualityBoard/WaterQualityBoardKeyFeaturesMobile.webp`;
const WaterQulaityBoardGrey = `${Configuration?.S3_URL}Products/WaterQualityBoard/WaterQualityBoardGrey.webp`;

const Port16ManagedSwitchHome = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/16portmanagedswitchhome.webp`;
const Port16ManagedSwitchGrey = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/16portmanagedswitchgrey.webp`;
const Port16ManagedSwitchKeyFeatures = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/16portmanagedswitchkeyfeatures.webp`;
const Port16ManagedSwitchcatalog1 = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/ProductCatalog/Catalog1.webp`;
const Port16ManagedSwitchcatalog2 = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/ProductCatalog/Catalog2.webp`;
const Port16ManagedSwitchcatalog3 = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/ProductCatalog/Catalog3.webp`;
const Port16ManagedSwitchcatalog4 = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/ProductCatalog/Catalog4.webp`;
const Port16ManagedSwitchcatalog5 = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/ProductCatalog/Catalog5.webp`;
const Port16ManagedSwitchcatalog6 = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/ProductCatalog/Catalog6.webp`;
const Port16ManagedSwitchKeyFeaturesMobile = `${Configuration?.S3_URL}Products/16PortL2ManagedSwitch/16portmanagedswitchkeyfeaturesmobile.webp`;

const Port16UnManagedSwitchKeyFeatures = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/Key Features.webp`;
const Port16UnManagedHome = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/Port16unmanagedHome.webp`;
const Port16UnManagedSwitchcatalog1 = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/ProductCatalog/Catalog1.webp`;
const Port16UnManagedSwitchcatalog2 = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/ProductCatalog/Catalog2.webp`;
const Port16UnManagedSwitchcatalog3 = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/ProductCatalog/Catalog3.webp`;
const Port16UnManagedSwitchcatalog4 = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/ProductCatalog/Catalog4.webp`;
const Port16UnManagedSwitchcatalog5 = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/ProductCatalog/Catalog5.webp`;
const Port16UnManagedSwitchcatalog6 = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/ProductCatalog/Catalog6.webp`;
const Port16unmanagedGrey = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/Port16unmanagedGrey.webp`;
const Port16UnManagedSwitchKeyFeaturesMobile = `${Configuration?.S3_URL}Products/16PortUnManagedSwitch/Port16unmanagedKeyfeaturesMobile.webp`;

const Port8ManagedSwitchcatalog1 = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/ProductCatalog/Catalog1.webp`;
const Port8ManagedSwitchcatalog2 = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/ProductCatalog/Catalog2.webp`;
const Port8ManagedSwitchcatalog3 = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/ProductCatalog/Catalog3.webp`;
const Port8ManagedSwitchcatalog4 = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/ProductCatalog/Catalog4.webp`;
const Port8ManagedSwitchcatalog5 = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/ProductCatalog/Catalog5.webp`;
const Port8ManagedSwitchcatalog6 = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/ProductCatalog/Catalog6.webp`;
const Port8ManagedHome = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/8portl2managedswitchhome.webp`;
const Port8ManagedSwitchKeyFeatures = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/8portl2managedswitchkeyfeatures.webp`;
const Port8ManagedGrey = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/8portl2managedgrey.webp`;
const Port8ManagedSwitchKeyFeaturesMobile = `${Configuration?.S3_URL}Products/8PortL2ManagedSwitch/8portl2managedswitchkeyfeaturesmobile.webp`;

const Port24ManagedSwitchcatalog1 = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/ProductCatalog/Catalog1.webp`;
const Port24ManagedSwitchcatalog2 = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/ProductCatalog/Catalog2.webp`;
const Port24ManagedSwitchcatalog3 = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/ProductCatalog/Catalog3.webp`;
const Port24ManagedSwitchcatalog4 = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/ProductCatalog/Catalog4.webp`;
const Port24ManagedSwitchcatalog5 = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/ProductCatalog/Catalog5.webp`;
const Port24ManagedSwitchcatalog6 = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/ProductCatalog/Catalog6.webp`;
const Port24ManagedSwitchHome = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/24PortManagedHome.webp`;
const Port24ManagedSwitchKeyFeatures = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/24PortManagedKeyFeatures.webp`;
const Port24ManagedGrey = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/24PortManagedGrey.webp`;
const Port24ManagedSwitchKeyFeaturesMobile = `${Configuration?.S3_URL}Products/24PortL2ManagedSwitch/24PortManagedKeyFeaturesMobile.png`;

const DualRedundantPScatalog1 = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/ProductCatalog/Catalog1.webp`;
const DualRedundantPScatalog2 = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/ProductCatalog/Catalog2.webp`;
const DualRedundantPScatalog3 = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/ProductCatalog/Catalog3.webp`;
const DualRedundantPScatalog4 = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/ProductCatalog/Catalog4.webp`;
const DualRedundantPScatalog5 = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/ProductCatalog/Catalog5.webp`;
const DualRedundantPScatalog6 = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/ProductCatalog/Catalog6.webp`;

const DualRedundantPSHome = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/RedundantPowerSupplyHome.webp`;
const DualRedundantPSKeyFeatures = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/RedundantPowerSupplyKeyFeatures.webp`;
const DualRedundantPSKeyFeaturesMobile = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/RedundantPowerSupplyKeyFeaturesMobile.webp`;
const DualRedundantPSGrey = `${Configuration?.S3_URL}Products/DualRedundantPowerSupply/RedundantPowerSupplyGrey.webp`;

const DisplayControllerscatalog1 = `${Configuration?.S3_URL}Products/DisplayControllers/ProductCatalog/Catalog1.webp`;
const DisplayControllerscatalog2 = `${Configuration?.S3_URL}Products/DisplayControllers/ProductCatalog/Catalog2.webp`;
const DisplayControllerscatalog3 = `${Configuration?.S3_URL}Products/DisplayControllers/ProductCatalog/Catalog3.webp`;
const DisplayControllerscatalog4 = `${Configuration?.S3_URL}Products/DisplayControllers/ProductCatalog/Catalog4.webp`;
const DisplayControllerscatalog5 = `${Configuration?.S3_URL}Products/DisplayControllers/ProductCatalog/Catalog5.webp`;
const DisplayControllerscatalog6 = `${Configuration?.S3_URL}Products/DisplayControllers/ProductCatalog/Catalog6.webp`;
const DisplayControllersHome = `${Configuration?.S3_URL}Products/DisplayControllers/DisplayControllersHome.webp`;
const DisplayControllersKeyFeatures = `${Configuration?.S3_URL}Products/DisplayControllers/DisplayControllersKeyFeatures.webp`;
const DisplayControllersKeyFeaturesMobile = `${Configuration?.S3_URL}Products/DisplayControllers/DisplayControllersKeyFeaturesMobile.webp`;
const DisplayControllersGrey = `${Configuration?.S3_URL}Products/DisplayControllers/DisplayControllersGrey.webp`;

const SerialInterfaceHome = `${Configuration?.S3_URL}Products/SerialInterfaceCards/SerialInterfaceHome.webp`;
const SerialInterfaceKeyFeatures = `${Configuration?.S3_URL}Products/SerialInterfaceCards/SerialInterfaceKeyFeatures.webp`;
const SerialInterfacecatalog1 = `${Configuration?.S3_URL}Products/SerialInterfaceCards/ProductCatalog/Catalog1.webp`;
const SerialInterfacecatalog2 = `${Configuration?.S3_URL}Products/SerialInterfaceCards/ProductCatalog/Catalog2.webp`;
const SerialInterfacecatalog3 = `${Configuration?.S3_URL}Products/SerialInterfaceCards/ProductCatalog/Catalog3.webp`;
const SerialInterfacecatalog4 = `${Configuration?.S3_URL}Products/SerialInterfaceCards/ProductCatalog/Catalog4.webp`;
const SerialInterfacecatalog5 = `${Configuration?.S3_URL}Products/SerialInterfaceCards/ProductCatalog/Catalog5.webp`;
const SerialInterfacecatalog6 = `${Configuration?.S3_URL}Products/SerialInterfaceCards/ProductCatalog/Catalog6.webp`;
const SerialInterfaceGrey = `${Configuration?.S3_URL}Products/SerialInterfaceCards/SerialInterfaceGrey.webp`;
const SerialInterfaceKeyFeaturesMobile = `${Configuration?.S3_URL}Products/SerialInterfaceCards/SerialInterfaceKeyFeaturesMobile.webp`;

export const Products = [
  //szephyr
  {
    ProductName: (<>s<span style={{ color: 'var(--primary-color)' }}>Zephyr</span></>),
    ProductDescription: (<>The <span style={{ color: 'var(--primary-color)' }}> Smart </span> Solution for Your ACs</>),
    ProductSubText: (<>The ultimate smart adapter for your room’s Air Conditioner</>),
    ProductFeatureSvg: SzephyrKeyFeatures,
    ProductFeatureImageMobile: SzephyrProductFeatures,
    HomeImage: SzephyrHomePage,
    MobileHomeImage: SzephyrMobileHomePage,
    CardText: [{
      heading: <>Why s<span style={{ color: 'var(--primary-color)' }}>Zephyr</span>?</>,
      description: "With sZephyr, you can control and monitor your AC from your smartphone using the exclusive mobile app. You can also use voice assistants like Alexa or Google Assistant to turn your AC on or off, check the temperature, or check the energy usage."
    }, {
      heading: <>What You <span style={{ color: 'var(--primary-color)' }}>Gain</span>?</>,
      description: "sZephyr reduces energy waste with smart automation, lowering your bills while keeping your space cool and efficient. It transforms your AC into a smart, connected system and delivering greater comfort, control, and cost-efficiency."
    }],
    features: [
      {
        steps: <>Plug your Szephyr into your<br /> wall socket</>,
        imagedesktop: SzephyrInstallationstep1,
        imagemobile: SzephyrInstallationstep1Mobile,
      },
      {
        steps: <>Install and connect your device</>,
        imagedesktop: SzephyrInstallationstep2,
        imagemobile: SzephyrInstallationstep2Mobile,
      },
      {
        steps: <>Plug your cable into Szephyr.</>,
        imagedesktop: SzephyrInstallationstep3,
        imagemobile: SzephyrInstallationstep3Mobile,
      },
    ],
    ApplicationPageHeading: (<>sZephyr <span style={{ color: 'var(--primary-color)' }}>&nbsp;App</span></>),
    Application: SzephyrMobileAppImage,
    MobileApplication: SzephyrMobileApplicationImage,
    specificationandwarranty: [
      {
        heading: "Why Choose sZephyr?",
        description: "Bring smart capabilities to your AC without the high cost of replacement. sZephyr lets you enjoy convenience, efficiency, and automation effortlessly.",
        position: "left"
      },
      {
        heading: "Safe and Durable Engineering",
        description: "Tested for fire safety and made with high-grade materials, sZephyr ensures consistent and secure performance throughout its lifespan.",
        position: "bottom"
      },
      {
        heading: "Warranty & Support",
        description: "sZephyr comes with a 1-year warranty covering manufacturing defects. Dedicated support ensures you stay worry-free while enjoying smart comfort.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Function:</span> Smart AC Controller with intelligent automation </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Cost-Effective:</span> Enjoy smart features without replacing your AC at a fraction of the cost</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Warranty:</span>Backed by a 1-year warranty for peace of mind Made in India: Built with high-quality components and local precision</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Certification:</span>CE certified and compliant with safety standards</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Fire Safety:</span> FR-grade plastic and passed 930°C glow wire test by IIT Madras.</> },
    ],
    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Energy saving",
        description: "Schedules, timers, and auto-shut off functions, track the energy usage, and get insights and recommendations to optimize consumption"
      },
      {
        icon: <ComfortIcon />,
        title: "Comfort",
        description: "sZephyr ensures optimal temperature can also create custom sleep profiles with multiple scheduling options"
      },
      {
        icon: <ConvenienceIcon />,
        title: "Convenience",
        description: "Lost your AC remote? No problem. Use sZephyr app to control your AC anywhere, voice commands to control, group multiple ACs and control them centrally."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Compatibility",
        description: "Compatible with all types of ACs, like split, window, or portable. It is easy to install and does not require any drilling or electrical operation. Just plug and play!"
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Protects your AC from power surges and alerts you if there is any unusual activity or maintenance issue"
      },
      // {
      //   icon: <InnovationIcon />,
      //   title: "Innovation",
      //   description: "Future-proof design that allows new features to be introduced without any hardware changes equipped with revolutionary AI Technology"
      // }
    ],
    ProductImages: [
      { src: SzephyrWhite, colorCode: 1 },
      { src: SzephyrGrey, colorCode: 2 },
      { src: SzephyrGreen, colorCode: 3 },
      { src: SzephyrBlue, colorCode: 4 },
    ],
    specifications: "sZephyr is a smart, cost-effective AC controller that upgrades your existing air conditioner with intelligent features, safety-tested durability, and seamless performance for modern homes.",
    partners: [{ svg: Rohs }, { svg: Cepassed }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Auto shut-off',
        desc: 'Automatically turn off your AC when the room temperature reaches the desired level',
      },
      {
        side: 'right',
        text: 'Power surge protection',
        desc: 'Protects the AC from voltage fluctuations',
      },
      {
        side: 'left',
        text: 'Remote control',
        desc: 'Control your AC from anywhere anytime using your phone',
      },
      {
        side: 'right',
        text: 'Energy usage monitoring',
        desc: 'Track how much energy your AC is using and how much it is costing you',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Scheduled ON/OFF',
        desc: 'Set timers and schedules for your AC to turn on or off automatically',
      },
      {
        side: 'left',
        text: 'Temperature monitoring',
        desc: 'Monitor and maintain optimal room temperature easily',
      },
      {
        side: 'right',
        text: 'Voice assistant enabled',
        desc: 'Control your AC with your voice using Alexa or Google Assistant',
      },
      {
        side: 'left',
        text: 'OTA firmware upgrade',
        desc: 'Keep your sZephyr up to date with the latest features and improvements',
      },
    ],
    WebApplicationModel: {
      section: {
        features1: "Perfect for Shared or Office Use - Team members or family can access the system from different devices.",
        features2: "Control every connected AC from a single screen, in real time.",
        features3: "Easily share access with service teams for faster troubleshooting and support.",
        idealLargeScreens: {
          title: "Ideal for Large Screens",
          description: "Dashboard view with detailed insights, graphs, and controls, optimized for desktops."
        },
        multiDeviceSync: {
          title: "Multi-Device Sync",
          description: "Your preferences, schedules, and usage data are always in sync across mobile and desktop."
        },
        image1: SzephyrWebApplication1,
        image2: SzephyrWebApplication2
      }
    },
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Easy Installation", key: "installation" },
      { step: 3, label: "Benefits", key: "benefits" },
      { step: 4, label: "Mobile and Web App", key: "application" },
      { step: 5, label: "Enquire Now", key: "enquirenow" },
      { step: 6, label: "Specifications", key: "specifications" },
    ],
    WebAppDifferentiation: {
      homeautomation: {
        heading: <>Smart AC <span style={{ color: 'var(--primary-color)' }}>Home</span> Automation</>,
        mobheading: "Smart AC Home Automation",
        tile1: "Family members can manage the system from their own devices.",
        tile2: "Securely share limited access with service professionals via the app for prompt troubleshooting.",
        img1: SzephyrHomeAutomation,
        img2: SzephyrMobileAppImage,
        applications: [
          {
            text: "Household Use"
          }, {
            text: "Domestic Applications"
          }
        ]
      },
      industrialautomation: {
        mobheading: "Smart AC Industrial Automation",
        heading: <>Smart AC <span style={{ color: 'var(--primary-color)' }}>Industrial</span> Automation</>,
        tile1: "Perfect for Shared or Office Use. Team members or family can access the system from different devices.",
        tile2: "Easily share access with service teams for faster troubleshooting and support.",
        img1: SzephyrIndustrialAutomation,
        img2: SzephyrIndustrialWebApp,
        applications: [
          { text: "Retail Sector" },
          { text: "Enterprises" },
          { text: "Manufacturing & Industry" }
        ]



      }
    }
  },

  //smazer
  {
    ProductName: (<>Sma<span style={{ color: 'var(--primary-color)' }}>Zer</span></>),
    ProductDescription: (<>The Best solution to make your Geyser <span style={{ color: 'var(--primary-color)' }}> Smart </span></>),
    ProductSubText: (<>India’s <span style={{ color: 'var(--primary-color)' }}>first</span> Smart water heater controller.</>),
    ApplicationPageHeading: (<>SmaZer <span style={{ color: 'var(--primary-color)' }}>&nbsp;App</span></>),
    ProductFeatureSvg: SmazerKeyFeatures,
    ProductFeatureImageMobile: SmazerProductFeatureMobile,
    HomeImage: SmazerHomePage,
    MobileHomeImage: SmazerMobileHomePage,
    CardText: [{
      heading: <>Why Sma<span style={{ color: 'var(--primary-color)' }}>Zer</span>?</>,
      description: "SmaZer is the smarter way to control your water heater. No need to replace your existing geyser just plug it in, connect to Wi-Fi, and gain full control from your smartphone. With built-in safety features, voice assistant compatibility, and energy tracking."
    }, {
      heading: <>What You <span style={{ color: 'var(--primary-color)' }}>Gain</span>?</>,
      description: "Control your geyser from anywhere with smart automation. Save energy, enhance safety, and enjoy effortless comfort."
    }],
    features: [
      {
        steps: <>Install sensor device in the Geyser</>,
        imagedesktop: SmazerInstallationstep1,
        imagemobile: SmazerInstallationstep1Mobile,
      },
      {
        steps: <>Plug your smazer into your geyser outlet</>,
        imagedesktop: SmazerInstallationstep2,
        imagemobile: SmazerInstallationstep2Mobile,
      },
      {
        steps: <>Install and connect your device</>,
        imagedesktop: SmazerInstallationstep3,
        imagemobile: SmazerInstallationstep3Mobile,
      },
      {
        steps: <>Plug the Geyser into the Adapter</>,
        imagedesktop: SmazerInstallationstep4,
        imagemobile: SmazerInstallationstep4Mobile,
      },
    ],

    Application: SmazerMobileAppImage,
    MobileApplication: SmazerMobileApplication,
    specificationandwarranty: [
      {
        heading: "Why Choose sZephyr?",
        description: "Bring smart capabilities to your AC without the high cost of replacement. sZephyr lets you enjoy convenience, efficiency, and automation effortlessly.",
        position: "left"
      },
      {
        heading: "Safe and Durable Engineering",
        description: "Tested for fire safety and made with high-grade materials, sZephyr ensures consistent and secure performance throughout its lifespan.",
        position: "bottom"
      },
      {
        heading: "Warranty & Support",
        description: "sZephyr comes with a 1-year warranty covering manufacturing defects. Dedicated support ensures you stay worry-free while enjoying smart comfort.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Smart Functionality:</span> Wi-Fi-enabled geyser controller with intelligent automation and voice control (Alexa & Google).</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Easy Installation: </span>Plug and play setup no drilling or rewiring required.</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Build & Safety:</span> Made in India with ABS FR-grade enclosure, CE certified, and passed 930°C glow wire test by IIT Madras.</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Design & Indicators:</span> Compact, space-saving design.</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Value & Support:</span> Cost-effective solution backed by a 1-year warranty.</> },
    ],
    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Energy saving",
        description: "Schedules, timers, and auto-shut off functions, track the energy usage, and get insights and recommendations to optimize consumption"
      },
      {
        icon: <ComfortIcon />,
        title: "Comfort",
        description: "SmaZer ensures you stay on top of your electricity and water bill. Provides recommendation on the optimal temperature and heating duration ensuring your comfort"
      },
      {
        icon: <ConvenienceIcon />,
        title: "Convenience",
        description: "Use smazer app to control your geyser anywhere, voice commands to control ,group multiple geysers and control them centrally."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Compatibility",
        description: "Compatible with all types of ACs, like split, window, or portable. It is easy to install and does not require any drilling or electrical operation. Just plug and play!"
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Protects your geyser from power surges and alerts you if there is any unusual activity or maintenance issue"
      },
      // {
      //   icon: <InnovationIcon />,
      //   title: "Innovation",
      //   description: "Future-proof design that allows new features to be introduced without any hardware changes equipped with revolutionary AI Technology"
      // }
    ],
    // ProductImages: [SmazerWhite, SmazerGrey, SmazerGreen, SmazerBlue],
    ProductImages: [
      { src: SmazerWhite, colorCode: 1 },
      { src: SmazerGrey, colorCode: 2 },
      { src: SmazerGreen, colorCode: 3 },
      { src: SmazerBlue, colorCode: 4 },
    ],
    specifications: "sZephyr is a smart, cost-effective AC controller that upgrades your existing air conditioner with intelligent features, safety-tested durability, and seamless performance for modern homes.",
    partners: [{ svg: Rohs }, { svg: Cepassed }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Auto shut-off',
        desc: 'Automatically turn off your Geyser when the water temperature reaches the desired level',
      },
      {
        side: 'right',
        text: 'Power surge protection',
        desc: 'Protect your Geyser from power fluctuations and surges that can damage it',
      },
      {
        side: 'left',
        text: 'Remote control',
        desc: 'Control your Geyser from anywhere anytime using your phone',
      },
      {
        side: 'right',
        text: 'Energy usage monitoring',
        desc: 'Track how much energy your Geyser is using and how much it is costing you',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Scheduled ON/OFF',
        desc: 'Set timers and schedules for your Geyser to turn on or off automatically',
      },
      {
        side: 'left',
        text: 'Temperature monitoring',
        desc: 'Monitor the water temperature. Prevent your loved ones from scalding and freezing',
      },
      {
        side: 'right',
        text: 'Voice assistant enabled',
        desc: 'Control your Geyser with your voice using Alexa or Google Assistant',
      },
      {
        side: 'left',
        text: 'OTA firmware upgrade',
        desc: 'Keep your Smazer up to date with the latest features and improvements',
      },
    ],
    WebApplicationModel: {
      section: {
        features1: "Perfect for Shared or Office Use - Team members or family can access the system from different devices.",
        features2: "Turn your geyser on/off, track energy use, and set schedules—all from a single screen.",
        features3: "Instantly share control with service providers for diagnostics and remote support.",
        idealLargeScreens: {
          title: "Ideal for Large Screens",
          description: "Dashboard view with detailed insights, graphs, and controls, optimized for desktops."
        },
        multiDeviceSync: {
          title: "Multi-Device Sync",
          description: "Your preferences, schedules, and usage data are always in sync across mobile and desktop."
        },
        image1: SmazerWebApplication1,
        image2: SmazerWebApplication2
      }
    },
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Easy Installation", key: "installation" },
      { step: 3, label: "Benefits", key: "benefits" },
      { step: 4, label: "Mobile and Web App", key: "application" },
      { step: 5, label: "Enquire Now", key: "enquirenow" },
      { step: 6, label: "Specifications", key: "specifications" },
    ],
    WebAppDifferentiation: {
      homeautomation: {
        heading: <><span style={{ color: 'var(--primary-color)' }}>Home</span> Automation</>,
        mobheading: "Home Automation",
        tile1: "Family members can manage the system from their own devices.",
        tile2: "Securely share limited access with service professionals via the app for prompt troubleshooting.",
        img1: SmazerHomeAutomation,
        img2: SmazerMobileAppImage,
        applications: [
          {
            text: "Household Use"
          }, {
            text: "Domestic Applications"
          }
        ]
      },
      industrialautomation: {
        heading: <><span style={{ color: 'var(--primary-color)' }}>Industrial</span> Automation</>,
        mobheading: "Industrial Automation",
        tile1: "Perfect for Shared or Office Use. Team members or family can access the system from different devices.",
        tile2: "Easily share access with service teams for faster troubleshooting and support.",
        img1: SmazerIndustrialAutomation,
        img2: SmazerIndustrialWebApp,
        applications: [
          { text: "Retail Sector" },
          { text: "Enterprises" },
          { text: "Manufacturing & Industry" }
        ]
      }
    }
  },

  //smampmax
  {
    ProductName: (<>SmAmp<span style={{ color: 'var(--primary-color)' }}>Max</span></>),
    ProductDescription: (<>Make your conventional appliances<span style={{ color: 'var(--primary-color)' }}>&nbsp;Smart </span> </>),
    ProductSubText: (<>Your ultimate destination for a <span style={{ color: 'var(--primary-color)' }}>smart home solution</span></>),
    ProductFeatureSvg: SmampMaxKeyFeatures,
    ProductFeatureImageMobile: SmampMaxProductFeaturesMobile,
    HomeImage: SmampMaxHomePage,
    MobileHomeImage: SmampMaxMobileHomePage,
    CardText: [{
      heading: <>Why SmAmp <span style={{ color: 'var(--primary-color)' }}>Max</span>?</>,
      description: "SmAmp Max is specifically designed for appliances those operates at the range of 15A. With SmAmp Max, you can control your appliances from anywhere  anytime. You can monitor your power usage and stay ahead of your electricity bill."
    }, {
      heading: <>What You <span style={{ color: 'var(--primary-color)' }}>Gain</span>?</>,
      description: "With SmAmp Max, you gain smarter control, improved convenience, better energy management, and enhanced safety—all in one simple, easy-to-use device."
    }],
    features: [
      {
        steps: <>Plug your SmAmp Max into your wall socket</>,
        imagedesktop: SmampMaxInstallationstep1,
        imagemobile: SmampMaxInstallationstep1Mobile,
      },
      {
        steps: <>Install and connect ur device</>,
        imagedesktop: SmampMaxInstallationstep2,
        imagemobile: SmampMaxInstallationstep2Mobile,
      },
      {
        steps: <>Plug your cable into SmAmp Max</>,
        imagedesktop: SmampMaxInstallationstep3,
        imagemobile: SmampMaxInstallationstep3Mobile,
      },
    ],
    ApplicationPageHeading: (<>SmAmp&nbsp;Max<span style={{ color: 'var(--primary-color)' }}>&nbsp;App</span></>),
    Application: SmampMaxMobileAppImage,
    MobileApplication: SmampMaxMobileApplication,
    specificationandwarranty: [
      {
        heading: "Smart Safety, Simplified",
        description: "SmampMax protects your appliances and enhances control without rewiring. Voltage and short-circuit protection keeps operations safe.",
        position: "left"
      },
      {
        heading: "Certified & Backed",
        description: "Make your existing appliances smart using a plug-and-play inline socket—ideal for both residential and commercial setups.",
        position: "bottom"
      },
      {
        heading: "Seamless Smart Upgrade",
        description: "Make your existing appliances smart using a plug-and-play inline socket—ideal for both residential and commercial setups.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>15A | 4000W:</span> Suitable for heavy appliances like fridges and washing machines</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>In-Line Mounting:</span> Compact design that fits directly into sockets</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>App Control:</span> Remote switching, scheduling, and monitoring via mobile app</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Safe & Durable</span>: CE certified, FR-grade fire-resistant body (930°C glow wire test) by IIT Madras.</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Made in India:</span> Built with premium materials; backed by 1-year warranty</> }
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Energy saving",
        description: "Schedules, timers, and auto-shut off functions, track the energy usage, and get insights and recommendations to optimize consumption"
      },
      {
        icon: <InnovationIcon />,
        title: "Innovation",
        description: "Future-proof design that allows new features to be introduced without any hardware changes equipped with revolutionary AI Technology"
      },
      {
        icon: <ConvenienceIcon />,
        title: "Convenience",
        description: "Use SmAmp Max app to control your appliances anywhere, voice commands to control ,group multiple appliances and control them centrally."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Compatibility",
        description: "Space saving design. It is easy to install and does not require any drilling or electrical operation. Just plug and play!"
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Protects your appliances from power surges and alerts you if there is any unusual activity or maintenance issue"
      }

    ],
    // ProductImages: [SmampMaxWhite, SmampMaxGrey, SmampMaxGreen, SmampMaxBlue],
    ProductImages: [
      { src: SmampMaxWhite, colorCode: 1 },
      { src: SmampMaxGrey, colorCode: 2 },
      { src: SmampMaxGreen, colorCode: 3 },
      { src: SmampMaxBlue, colorCode: 4 },
    ],
    specifications: "SmAmpMax is a smart inline socket designed for safety, control, and convenience. It supports 4000 W / 15 A loads, enables remote and voice control, and features smart automation with real-time energy insights.",
    partners: [{ svg: Rohs }, { svg: Cepassed }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Countdown Timer',
        desc: 'Set a countdown timer for your appliance to turn off after a certain period of time',
      },
      {
        side: 'right',
        text: 'Power surge protection',
        desc: 'Protect your appliance from power fluctuations and surges that can damage it',
      },
      {
        side: 'left',
        text: 'Remote control',
        desc: 'Control your appliance from anywhere anytime using your phone',
      },
      {
        side: 'right',
        text: 'Energy usage monitoring',
        desc: 'Track how much energy your appliance is using and how much it is costing you',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Scheduled ON/OFF',
        desc: 'Set timers and schedules for your appliance to turn on or off automatically',
      },
      {
        side: 'left',
        text: 'Voice assistant enabled',
        desc: 'Control your appliance with your voice using Alexa or Google Assistant',
      },
      {
        side: 'right',
        text: 'OTA firmware upgrade',
        desc: 'Keep your SmAmp Max up to date with the latest features and improvements',
      },
      // {
      //   side: 'left',
      //   text: 'OTA firmware upgrade',
      //   desc: 'Keep your sZephyr up to date with the latest features and improvements',
      // },
    ],

    WebApplicationModel: {
      section: {
        features1: "Perfect for Shared or Office Use - Team members or family can access the system from different devices.",
        features2: "Turn your applicances on/off, track energy use, and set schedules—all from a single screen.",
        features3: "Instantly share control with service providers for diagnostics and remote support.",
        idealLargeScreens: {
          title: "Ideal for Large Screens",
          description: "Dashboard view with detailed insights, graphs, and controls, optimized for desktops."
        },
        multiDeviceSync: {
          title: "Multi-Device Sync",
          description: "Your preferences, schedules, and usage data are always in sync across mobile and desktop."
        },
        image1: SmampMaxWebApplication1,
        image2: SmampMaxWebApplication2
      },
    },
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Easy Installation", key: "installation" },
      { step: 3, label: "Benefits", key: "benefits" },
      { step: 4, label: "Mobile and Web App", key: "application" },
      { step: 5, label: "Enquire Now", key: "enquirenow" },
      { step: 6, label: "Specifications", key: "specifications" },
    ],
    WebAppDifferentiation: {
      homeautomation: {
        heading: <><span style={{ color: 'var(--primary-color)' }}>Home</span> Automation</>,
        mobheading: "Home Automation",
        tile1: "Family members can manage the system from their own devices.",
        tile2: "Securely share limited access with service professionals via the app for prompt troubleshooting.",
        img1: SmampMaxHomeAutomation,
        img2: SmampMaxMobileAppImage,
        applications: [
          {
            text: "Household Use"
          }, {
            text: "Domestic Applications"
          }
        ]
      },
      industrialautomation: {
        heading: <><span style={{ color: 'var(--primary-color)' }}>Industrial</span> Automation</>,
        mobheading: "Industrial Automation",
        tile1: "Perfect for Shared or Office Use. Team members or family can access the system from different devices.",
        tile2: "Easily share access with service teams for faster troubleshooting and support.",
        img1: SmampMaxIndustrialAutomation,
        img2: SmampMaxIndustrialWebApp,
        applications: [
          { text: "Retail Sector" },
          { text: "Enterprises" },
          { text: "Manufacturing & Industry" }
        ]
      }
    }
  },

  //smartpanel
  {
    ProductName: (<>Inno<span style={{ color: 'var(--primary-color)' }}>mate</span></>),
    ProductDescription: (<>Intelligent Energy Management at Your<span style={{ color: 'var(--primary-color)' }}>&nbsp;Fingertips</span> </>),
    ProductSubText: (<>Effortlessly manage raw and inverter power, monitor<span style={{ color: 'var(--primary-color)' }}>&nbsp;energy consumption</span></>),
    ProductFeatureSvg: SmartPanelKeyFeatures,
    ProductFeatureImageMobile: SmartPanelFeatureMobile,
    HomeImage: SmartpanelHomePage,
    MobileHomeImage: SmartpanelMobileHomePage,
    CardText: [{
      heading: <>Why Inno<span style={{ color: 'var(--primary-color)' }}>mate</span>?</>,
      description: "Introducing the Innomate – the next generation of home power management. This innovative panel puts you in command, offering unparalleled control, real-time insights, and ultimate peace of mind."
    }, {
      heading: <>How it <span style={{ color: 'var(--primary-color)' }}>Works</span>?</>,
      description: "Seamlessly integrating into your existing electrical system, our Innomate replaces your old, inefficient setup. With built-in smart relays, precise energy monitoring, and advanced wireless communication, you can manage your power from anywhere."
    }],
    features: [
      {
        steps: <>Plug your Innomate into your Switch Board</>,
        imagedesktop: Smartpanelinstallationguide1,
        imagemobile: Smartpanelinstallationguidemobile1,
      },
      {
        steps: <>Log in through any web browser for instant, hassle free control.</>,
        imagedesktop: Smartpanelinstallationguide2,
        imagemobile: Smartpanelinstallationguidemobile2,
      },
      {
        steps: <>Seamlessly switch connected devices on or off from anywhere, at any time.</>,
        imagedesktop: Smartpanelinstallationguide3,
        imagemobile: Smartpanelinstallationguidemobile3
      },
    ],
    specificationandwarranty: [
      {
        heading: "Smart Safety, Simplified",
        description: "Protect your appliances with in-built surge and short-circuit protection. Designed for safe operation without rewiring, keeping your energy system secure and reliable.",
        position: "left"
      },
      {
        heading: "Certified & Backed",
        description: "CE-certified and built with fire-retardant ABS housing. Backed by a 1-year warranty to ensure durability, performance, and peace of mind in everyday use.",
        position: "bottom"
      },
      {
        heading: "Seamless Smart Upgrade",
        description: "Replace your traditional panel effortlessly. Our smart panel integrates into your existing system, enabling remote monitoring and automation for both residential and commercial use.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>In-Line Mounting:</span> Compact design that fits directly into sockets.</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>App Control:</span> Remote switching, scheduling, and monitoring via mobile app. </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Safe & Durable</span>: CE certified, FR-grade fire-resistant body (930°C glow wire test) by IIT Madras.</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Made in India:</span> Built with premium materials; backed by 1-year warranty</> }
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Energy saving",
        description: "Monitor and manage power usage in real time. Schedule operations, set consumption limits, and receive smart recommendations to reduce your electricity bills."
      },
      {
        icon: <CompactandElegantDesign />,
        title: "Compact & Elegant Design",
        description: "Works with any standard home wiring. No rewiring or wall modifications required—professional installation ensures smooth integration with your existing system."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Convenience",
        description: "Control all connected circuits—lighting, appliances, inverter loads—from a single dashboard via browser. No need for multiple switches or remotes."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Compatibility",
        description: "Works with any standard home wiring. No rewiring or wall modifications required—professional installation ensures smooth integration with your existing system."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Built-in protection against overloads, surges, and short circuits. Instant alerts notify you of anomalies or power irregularities for total peace of mind."
      }

    ],
    // ProductImages: [SmartPanelWhite, SmartPanelGrey],
    ProductImages: [
      { src: SmartPanelWhite, colorCode: 1 },
      { src: SmartPanelGrey, colorCode: 2 },
    ],
    specifications: "Innomate is a next-gen smart electrical solution designed to deliver unmatched safety, connectivity, and control. It supports 6 relays (4 Raw + 2 Inverter), enables real-time energy monitoring, and features seamless browser-based control with Wi-Fi + BLE for total home automation.",
    partners: [{ svg: Rohs }, { svg: Cepassed }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Dual-Source Power Management',
        desc: 'Independently manage grid (raw) and inverter power for smarter load distribution.',
      },
      {
        side: 'right',
        text: 'Real-Time Monitoring',
        desc: 'View live power usage for each relay and identify high-consumption zones.',
      },
      {
        side: 'left',
        text: 'Remote control',
        desc: 'Control your appliance from anywhere anytime',
      },
      {
        side: 'right',
        text: 'Connectivity',
        desc: 'Control your smart panel remotely via Wi-Fi or locally via Bluetooth Low Energy (BLE), ensuring seamless access anytime, anywhere',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Scheduled ON/OFF',
        desc: 'Set timers and schedules for your appliance to turn on or off automatically',
      },
      {
        side: 'left',
        text: 'Voice assistant enabled',
        desc: 'Control your appliance with your voice using Alexa or Google Assistant',
      },
      {
        side: 'right',
        text: 'OTA firmware upgrade',
        desc: 'Keep your Smart panel up to date with the latest features and improvements',
      }
    ],

    WebApplicationModel: {
      section: {
        features1: "Multiple users can securely access and control the smart panel from different devices, ensuring seamless power management across teams or shared spaces.",
        features2: "Turn your applicances on/off, track energy use, and set schedules—all from a single screen.",
        features3: "Instantly share control with service providers for diagnostics and remote support.",
        idealLargeScreens: {
          title: "Ideal for Large Screens",
          description: "Dashboard view with detailed insights, graphs, and controls, optimized for desktops."
        },
        multiDeviceSync: {
          title: "Multi-Device Sync",
          description: "Your preferences, schedules, and usage data are always in sync across mobile and desktop."
        },
        image1: SmartPanelWebApplication1,
        image2: SmartPanelWebApplication2
      }
    },

    ProductCatalog: [
      {
        f1: "White Finish",
        f2: "6 Smart Relays",
        image: Smartpanelcatalog1
      },
      {
        f1: "Wi-Fi + BLE",
        f2: "4 Raw | 2 Inverter",
        image: Smartpanelcatalog2
      },
      {
        f1: "5A Per Relay",
        f2: "Energy Insights",
        image: Smartpanelcatalog3
      },
      {
        f1: "Browser Control",
        f2: "Real-Time Monitoring",
        image: Smartpanelcatalog4
      },
      {
        f1: "Grey Finish",
        f2: "Real-Time Monitoring",
        image: Smartpanelcatalog5
      },
      {
        f1: "Plug & Play",
        f2: "Fire-Retardant Housing",
        image: Smartpanelcatalog6
      }
    ],
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Easy Installation", key: "installation" },
      { step: 3, label: "Product Catalog and WebApp", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ]
  },

  //ethernetrinfmediaconvertor

  {
    IsHoriz: true,
    ProductName: (<span>RedunLink<br /><span style={{ color: 'var(--primary-color)' }}> RS232-2F</span></span>),
    ProductDescription: (<>High-Availability<span style={{ color: 'var(--primary-color)' }}> Protocol Conversion </span>for Critical Infrastructure </>),
    ProductSubText: (<>The RedunLink RS232-2F is an industrial-grade device that converts legacy serial protocols to modern Ethernet standards while ensuring uninterrupted communication through redundant Ethernet ring technology.</>),
    ProductFeatureSvg: EthernetRingKeyFeatures,
    ProductFeatureImageMobile: Ethernetfeaturesmobile,
    HomeImage: EthernetHomePage,
    MobileHomeImage: EthernetHomePage,
    specificationandwarranty: [
      {
        heading: "Industrial-Grade Reliability",
        description: "Built for harsh conditions with an IP30-rated metal enclosure, wide temperature support (-40°C to +75°C), and dual power input.",
        position: "bottom"
      },
      {
        heading: "Certified & Backed",
        description: "CE-compliant and manufactured with robust industrial-grade components. Includes a 1-year warranty ensuring performance, longevity, and peace of mind across deployments.",
        position: "left"
      },
      {
        heading: "Seamless Protocol Bridging",
        description: "Connect legacy serial devices to Ethernet systems effortlessly. It allows smooth migration without changing your existing devices, enabling real-time communication in industrial and utility environments.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Serial Ports:</span> 1–2x RS-232/485/422</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ethernet Ports:</span> 2x SFP 10/100/1000 Mbps</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Supported Protocols:</span> Modbus RTU/ASCII, DNP3, IEC 101 to Modbus TCP/IP, DNP3 TCP, IEC 104</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Fiber Optimization:</span> 4-core fiber for multi-channel</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temp:</span> -40°C to +75°C</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span> 9–36VDC Dual Redundant Input</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Enclosure:</span> IP30 Metal Housing</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span> DIN-Rail</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Dimensions:</span> 50mm x 140mm x 110mm (Approx.)</> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Efficient Fiber Usage",
        description: "By supporting multiple serial channels through just four-core fiber, the device reduces cabling complexity and lowers infrastructure costs—perfect for large-scale and distributed systems."
      },
      {
        icon: <CompactandElegantDesign />,
        title: "Legacy System Integration",
        description: "Easily connect serial-based devices such as RTUs, PLCs, and sensors to modern Ethernet networks. This enables seamless infrastructure upgrades without replacing existing field equipment."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Uninterrupted Communication",
        description: "The RedunLink RS232-2F ensures continuous data transmission with built-in ring redundancy, delivering zero packet loss even during network failures. It is ideal for mission-critical environments where uptime is non-negotiable."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Compatibility",
        description: "Housed in an IP30-rated metal enclosure, the converter is built to withstand dust, vibration, EMI, and extreme temperatures. It performs reliably in tough industrial and outdoor conditions."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Protect your device and data with secure access, optional encryption, and basic firewall features. This safeguards your critical operations from unauthorized access and cyber risks."
      }

    ],
    // ProductImages: [EthernetWhite],
    ProductImages: [
      { src: EthernetWhite, colorCode: 1 },
    ],
    specifications: "The RedunLink RS232-2F is a next-generation industrial solution designed to deliver unmatched reliability, protocol flexibility, and network resilience. It enables seamless conversion between legacy serial protocols such as Modbus RTU, DNP3, and IEC 101, and modern Ethernet standards like Modbus TCP/IP, DNP3 TCP, and IEC 104. With built-in ring redundancy, it ensures uninterrupted communication and zero data loss—making it ideal for critical infrastructure and automation environments.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Fiber Core Optimization',
        desc: 'Reduces core usage to just 4 fiber cores for multiple serial channels.',
      },
      {
        side: 'right',
        text: 'Wide Temperature Range',
        desc: 'Operates reliably from -40°C to +75°C in harsh conditions.',
      },
      {
        side: 'left',
        text: 'Secure Web Interface',
        desc: 'Control Remote access, SNMP monitoring, and firewall-capable setup. appliance from anywhere anytime',
      },
      // {
      //   side: 'right',
      //   text: 'Connectivity',
      //   desc: 'Control your smart panel remotely via Wi-Fi or locally via Bluetooth Low Energy (BLE), ensuring seamless access anytime, anywhere',
      // },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Ring Redundancy',
        desc: 'Zero packet loss during failure with seamless bumpless recovery.',
      },
      {
        side: 'left',
        text: 'Multi-Protocol Support',
        desc: 'Supports Modbus, DNP3, IEC 60870 across both serial and Ethernet interfaces.',
      },
      {
        side: 'right',
        text: 'Configurable Serial Ports',
        desc: 'RS-232, RS-485, RS-422 with selectable baud rates.',
      }
    ],

    ProductCatalog: [
      {
        f1: "Reliable Redundancy",
        f2: "Zero Packet Loss",
        image: Ethernetcatalog1
      },
      {
        f1: "DIN-Rail Mountable",
        f2: "Industrial-Grade Build",
        image: Ethernetcatalog2
      },
      {
        f1: "Multi-Protocol Support",
        f2: "4-Core Fiber Optimized",
        image: Ethernetcatalog3
      },
      {
        f1: "Legacy Device Integration",
        f2: "Modbus / DNP3 / IEC Compatible",
        image: Ethernetcatalog4
      },
    ],
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ]
  },

  //serialtoredundantfiberextender
  {
    IsHoriz: true,
    ProductName: (<span>Serial to Redundant <span style={{ color: 'var(--primary-color)' }}> Fiber Extender</span></span>),
    ProductDescription: (<>Uninterrupted Data Transmission for Industrial <span style={{ color: 'var(--primary-color)' }}> RS232</span> Applications </>),
    ProductSubText: (<>Extend RS232 signals over long distances with up to 80 Km fiber support, built-in dual SFP redundancy, and robust industrial-grade design. Designed for critical infrastructure and legacy device integration.</>),
    ProductFeatureSvg: SerialToRedundantKeyFeatures,
    ProductFeatureImageMobile: SerialToRedundantfeaturesmobile,
    HomeImage: SerialToRedundantHomePage,
    MobileHomeImage: SerialToRedundantHomePage,
    specificationandwarranty: [
      {
        heading: "Static & Surge Immunity",
        description: "Built-in protection safeguards against electrical disturbances.",
        position: "bottom"
      },
      {
        heading: "Industrial Build",
        description: "IP30 steel enclosure with thermal heat sink and wide temperature support.",
        position: "left"
      },
      {
        heading: "Dual Power Protection",
        description: "24V DC Dual Input with reverse polarity protection ensures continuous power delivery.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Serial Ports:</span> 2 × RS-232 (DB25, Full Handshake)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ethernet/Fiber Ports:</span> 2 × SFP (100M / 1G, Hot-Swappable)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Supported Protocols:</span> Transparent RS232 over Fiber (Modbus, SCADA, Legacy Devices)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Fiber Optimization:</span> Supports 2-core (SFP) & Single-core WDM (Bi-Di SFP)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temp:</span> -40°C to +85°C</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span> 9–36VDC Dual Input with Reverse Polarity Protection</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Enclosure:</span> IP30 Industrial Metal Housing</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span> DIN Rail & Screw Mount Compatible</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Dimensions:</span> 250mm × 120mm × 48mm</> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Zero Downtime Redundancy",
        description: "Dual-fiber hot-swappable SFP ensures uninterrupted operation even during fiber failure — no packet loss, no recovery delay."
      },
      {
        icon: <CompactandElegantDesign />,
        title: "Industrial Reliability",
        description: "Operates in extreme conditions from -40°C to +85°C with integrated static, surge, and thermal protection."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Extended Communication Reach",
        description: "Surpass traditional RS232 limits by extending communication up to 80 km over fiber."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Plug-and-Play Simplicity",
        description: "Auto-turnaround logic enables easy setup without the need for complex software or configuration."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Ensures reliable and interference-resistant communication with optical isolation and built-in surge protection — ideal for security-critical environments."
      }

    ],
    // ProductImages: [SerialToRedundantKeyGrey],
    ProductImages: [
      { src: SerialToRedundantKeyGrey, colorCode: 1 },
    ],
    specifications: "The IN-SRFX-20D ensures uninterrupted RS232 data transmission using dual-fiber SFP redundancy. Designed for mission-critical industrial communication, it features dual hot-swappable SFP ports that switch instantly upon failure.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Dual RS232 Ports with Handshake Support',
        desc: 'Ensure full-duplex communication with legacy devices using CTS/RTS flow control.',
      },
      {
        side: 'right',
        text: 'Redundant SFP Fiber Link',
        desc: 'Zero recovery time ensures realtime seamless communication even during fiber failure.',
      },
      {
        side: 'left',
        text: 'Extended Range up to 80 km',
        desc: 'Overcome RS232 distance limits using long-range SFP modules.',
      },
      // {
      //   side: 'right',
      //   text: 'Connectivity',
      //   desc: 'Control your smart panel remotely via Wi-Fi or locally via Bluetooth Low Energy (BLE), ensuring seamless access anytime, anywhere',
      // },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Industrial Grade IP30 Steel Enclosure',
        desc: 'Designed for harsh environments with built-in surge and thermal protection.',
      },
      {
        side: 'left',
        text: 'Flexible Mounting Options',
        desc: 'DIN rail & screw-mountable with compact footprint.',
      },
      {
        side: 'right',
        text: 'Real-time Status LEDs',
        desc: 'Quick diagnostics for link status, data flow, and power state.',
      }
    ],

    ProductCatalog: [
      {
        f1: "Redundant",
        f2: "Reliable",
        image: Srfxcatalog1
      },
      {
        f1: "Rugged",
        f2: "Seamless",
        image: Srfxcatalog2
      },
      {
        f1: "Compact",
        f2: "Hot-swappable",
        image: Srfxcatalog3
      },
      {
        f1: "Versatile",
        f2: "Industrial",
        image: Srfxcatalog4
      },
      {
        f1: "Extended",
        f2: "Precise",
        image: Srfxcatalog5
      },
      {
        f1: "Failproof",
        f2: "Secure",
        image: Srfxcatalog6
      },
    ],
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ]
  },

  //uhf radio modem
  {
    IsHoriz: true,
    ProductName: (<span>RelaiLink <span style={{ color: 'var(--primary-color)' }}> UHF-X</span></span>),
    ProductDescription: (<>Uninterrupted <span style={{ color: 'var(--primary-color)' }}> Wireless</span>  Communication for Industrial RS232 Applications </>),
    ProductSubText: (<>The RelaiLink UHF-X is a rugged, high-performance solution built for demanding railway and industrial environments. Proudly indigenously designed and manufactured in India, it ensures secure, long-range, and reliable communication, critical for enhancing safety, monitoring, and automation.</>),
    ProductFeatureSvg: UhfRadioModemKeyFeatures,
    ProductFeatureImageMobile: UHFfeaturesmobile,
    HomeImage: UhfRadioModemHome,
    MobileHomeImage: UhfRadioModemHomeMobile,
    specificationandwarranty: [
      {
        heading: "Data Power Standards",
        description: "1-10 Watts RF Output | 2FSK Modulation | 100% Duty Cycle",
        position: "bottom"
      },
      {
        heading: "Electrical & Signal Versatility",
        description: "Dual RS-232 Ports | Adjustable Bandwidth | Full/half/simplex modes",
        position: "left"
      },
      {
        heading: "Product Build",
        description: "Meets RDSO/SPN/196/2020 Ver 4.0 | Tested per SIF1505 Ver 1.0",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Frequency Range:</span>406–470 MHz</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Channel Bandwidth:</span> 12.5 kHz and 25 kHz</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Modulation:</span> 2FSK with high spectral efficiency</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>RF Output Power:</span> Adjustable from 1 to 10 Watts</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Bit Error Rate:</span> Up to -110 dBm @ 4.8 kbps (BER 1×10⁻⁶)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Modes:</span> Modem & Analog – Simplex, Half-Duplex, Full-Duplex</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span>  10–30 VDC with power foldback protection</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temperature:</span>  -30°C to +60°C (Up to +70°C with 50% duty cycle at 10W)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Serial Interfaces:</span>  2 × RS-232 (DB-9, COM1 & COM2)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Compliance:</span>   RDSO/SPN/196/2020 Ver 4.0 & Tested as per SIF1505 (Ver 1.0)</> },

    ],



    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Robust Power Flexibility",
        description: "Supports wide input voltage range (10–30 VDC), offering compatibility with various railway and industrial power sources."
      },
      {
        icon: <ComfortIcon />,
        title: "Industrial-Grade Resilience",
        description: "Built to withstand extreme temperatures and humidity, ensuring consistent performance in challenging railway environments."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Reliable Long-Distance Data Transmission",
        description: "Ensures robust, uninterrupted connectivity even under mobile and harsh field conditions, making it ideal for mission-critical communication."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Kavach Compatible",
        description: "Fully supports interoperability with Indian Railway’s Kavach Train Protection System for seamless integration and operational safety."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Supports error-free data transmission with robust modulation, frequency stability, and low bit error rate, ensuring secure communication in safety-critical applications."
      },
      {
        //   icon: <InnovationIcon />,
        icon: <InnovationIcon />,
        title: "Scalable for Diverse Applications",
        description: "Optimized for railway signaling, telemetry, remote monitoring and control, and voice over RS-232 communication systems."
      },

    ],
    // ProductImages: [UhfRadioModemGrey],
    ProductImages: [
      { src: UhfRadioModemGrey, colorCode: 1 },
    ],
    specifications: "The RelaiLink UHF-X is engineered with precision to meet RDSO standards and environmental requirements of Indian Railways. It offers reliable performance, high power efficiency, and robust connectivity with compact design.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Wideband UHF Communication',
        desc: 'Covers 406–470 MHz frequency range with 12.5/25 kHz bandwidth support.',
      },
      {
        side: 'right',
        text: 'High Receiver Sensitivity',
        desc: 'BER of 1×10⁻⁶: up to -110 dBm, ideal for long-range clarity.',
      },
      {
        side: 'left',
        text: 'Multiple Operation Modes',
        desc: 'Control your AC from anywhere anytime using your Supports Modem & Analog: Simplex, Half-duplex, Full-duplex.',
      },
      {
        side: 'right',
        text: 'Robust & Efficient Design',
        desc: 'Compact, lightweight, and RDSO compliant.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Kavach System Interoperability',
        desc: 'Fully compatible with existing Kavach infrastructure; meets RDSO/SPN/196/2020 Ver 4.0 standards.',
      },
      {
        side: 'left',
        text: 'Environmental Resilience',
        desc: 'Operates reliably in -30°C to +60°C range; withstands up to 95% non-condensing humidity.',
      },
      {
        side: 'right',
        text: 'Dual RS-232 Serial Ports',
        desc: 'Standard DB-9 connectors for data input/output.',
      },
      {
        side: 'left',
        text: 'Dynamic Power Output',
        desc: '1–10 watts RF power with 100% duty cycle and foldback protection.',
      }
    ],

    ProductCatalog: [
      {
        f1: "Reliable UHF Performance",
        f2: "Engineered for Railways",
        image: Uhfcatalog1
      },
      {
        f1: "Long-Range Connectivity",
        f2: "Zero Compromise Data",
        image: Uhfcatalog2
      },
      {
        f1: "Kavach Compatible",
        f2: "Future-Ready Design",
        image: Uhfcatalog3
      },
      {
        f1: "Extreme Condition Tested",
        f2: "Always Stable, Always On",
        image: Uhfcatalog4
      },
      {
        f1: "No Packet Loss",
        f2: "Seamless Serial Transfer",
        image: Uhfcatalog5
      },
      {
        f1: "Precision Meets Power",
        f2: "Secure. Strong. Scalable",
        image: Uhfcatalog6
      },
    ],
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ]
  },

  //embedded pc
  {
    IsHoriz: true,
    ProductName: (<span>RuggedEdge <br /><span style={{ color: 'var(--primary-color)' }}> MPU-65</span></span>),
    ProductDescription: (<>Uninterrupted Performance for  <span style={{ color: 'var(--primary-color)' }}> Industrial Applications</span></>),
    ProductSubText: (<>Our indigenously designed and manufactured RuggedEdge MPU-65 is a robust solution engineered to thrive in harsh industrial environments. It enables seamless monitoring, control, and data processing for mission-critical applications, with rugged construction, wide I/O support, and intelligent expandability.</>),
    ProductFeatureSvg: EmbeddedPcKeyFeatures,
    ProductFeatureImageMobile: EmbeddedPcKeyFeaturesMobile,
    HomeImage: EmbeddedPcHome,
    MobileHomeImage: EmbeddedPcHome,
    specificationandwarranty: [
      {
        heading: "Data Power Standards",
        description: "Dual GbE M12 Ethernet, SIM slot, and SMA ports for 4G, Wi-Fi, and GPS. High-speed data access and secure communication under harsh conditions.",
        position: "bottom"
      },
      {
        heading: "Electrical & Signal Versatility",
        description: "Wide 9–36VDC input with 24VDC M12 connector. Rich I/O: RS232/485, USB 3.0, HDMI, Audio, and GPIO supported.",
        position: "left"
      },
      {
        heading: "Product Build",
        description: "Built with industrial-grade components in a compact IP65 enclosure.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>CPU:</span>Intel Core i5 – 5th Gen</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>RAM:</span> 8GB DDR3</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Storage:</span> 256GB SSD Built-In</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Display:</span> 7" Capacitive Touch, 1024x600 </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Audio:</span> M12 Mic, Line In/Out, Speaker</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>USB:</span> 2 x USB 3.0, 1 x M12 USB</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Network:</span>  2 x M12 GbE, SIM Slot, 4G/Wi-Fi/GPS SMA </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power:</span>  24VDC via M12, 9–36VDC supported</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>OS:</span>  Windows 10 / Linux</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span>  IP65</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Enclosure:</span>  Wall Mount</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Certification:</span>  EN50155 (To be complied)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temp:</span>  -20°C to +75°C</> },

    ],



    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Robust Power Flexibility",
        description: "Supports wide input voltage range (9–36 VDC), ensuring seamless integration with diverse industrial power setups, including mobile and remote installations."
      },
      {
        icon: <Temperature />,
        title: "Industrial-Grade Resilience",
        description: "Engineered to operate reliably in harsh industrial environments, withstanding extreme temperatures, vibrations, and dust—ideal for rugged field deployments."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Reliable Connectivity Options",
        description: "Equipped with dual GbE Ethernet, SIM socket, and SMA ports for 4G, Wi-Fi, and GPS, ensuring uninterrupted communication in remote or demanding sites."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Smart HMI Integration",
        description: "Integrated 7 capacitive touchscreen enables intuitive human-machine interaction, reducing the need for external display units in control panels."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Future-ready with PCIe, M.2, and Mini PCIe slots—easily adapt and upgrade the system with custom modules as your needs evolve."
      },
      {
        icon: <InnovationIcon />,
        title: "Multi-System Compatibility",
        description: "Fully supports both Windows and Linux platforms, ensuring broad application support and compatibility across various industrial software systems."
      },

    ],
    // ProductImages: [EmbeddedpcGrey],
    ProductImages: [
      { src: EmbeddedpcGrey, colorCode: 1 },
    ],
    specifications: "The RuggedEdge MPU-65 is engineered with precision to meet demanding industrial standards, ensuring optimal performance, rugged reliability, and long-term durability. It combines versatile connectivity, modular expansion, and environmental resilience—making it the perfect solution for complex industrial applications.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Powerful Performance',
        desc: 'Intel Core i5 5th Gen Processor with 8GB DDR3 RAM and 256GB SSD built-in.',
      },
      {
        side: 'right',
        text: 'Wide Connectivity',
        desc: '2 x RS485, 1 x RS232, 2 x USB 3.0, 2 x GbE Ethernet, SIM socket, and SMA antenna ports for 4G/Wi-Fi/GPS.',
      },
      {
        side: 'left',
        text: 'Modular Expandability',
        desc: 'PCIe, M.2, and Mini PCIe slots enable future customization and system scaling.',
      },
      {
        side: 'right',
        text: 'Integrated Display',
        desc: '7" Capacitive Touch Screen with 1024x600 resolution for intuitive HMI.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'High-Speed Storage',
        desc: 'Comes with built-in 256GB SSD and provision for mounting 2 external HDDs, ensuring fast data access and scalability.',
      },
      {
        side: 'left',
        text: 'Multi-OS Support',
        desc: 'Compatible with both Windows 10 and Linux distributions for greater flexibility across industrial applications.',
      },
      {
        side: 'right',
        text: 'Industrial Durability',
        desc: 'IP65-rated enclosure, wide input voltage (9–36VDC), and operating range from -20°C to 75°C.',
      },
      {
        side: 'left',
        text: 'Dynamic Power Output',
        desc: 'Wall mount-ready with compact form factor and robust build.',
      }
    ],

    ProductCatalog: [
      {
        f1: "Reliable UHF Performance",
        f2: "Engineered for Railways",
        image: Embeddedpccatalog1
      },
      {
        f1: "Long-Range Connectivity",
        f2: "Zero Compromise Data",
        image: Embeddedpccatalog2
      },
      {
        f1: "Kavach Compatible",
        f2: "Future-Ready Design",
        image: Embeddedpccatalog3
      },
      {
        f1: "Extreme Condition Tested",
        f2: "Always Stable, Always On",
        image: Embeddedpccatalog4
      },
      {
        f1: "No Packet Loss",
        f2: "Seamless Serial Transfer",
        image: Embeddedpccatalog5
      },
      {
        f1: "Precision Meets Power",
        f2: "Secure. Strong. Scalable",
        image: Embeddedpccatalog6
      },
    ],
    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ]
  },

  //miniaturempmc
  {
    IsHoriz: true,
    ProductName: (<span>InduX <span style={{ color: 'var(--primary-color)' }}> Edge 8</span> </span>),
    ProductDescription: (<>Compact, Continuous  <span style={{ color: 'var(--primary-color)' }}> Control & Monitoring</span></>),
    ProductSubText: (<>This miniature control system delivers powerful automation in a compact form. Perfectly suited for embedded and space-constrained environments, it combines multi-sensor interfacing, rich communication protocols, and rugged design into one seamless solution.</>),
    ProductFeatureSvg: MiniaturemscsKeyFeatures,
    ProductFeatureImageMobile: MiniaturemscsKeyFeaturesMobile,
    HomeImage: MiniaturemscsHome,
    MobileHomeImage: MiniaturemscsHome,
    specificationandwarranty: [
      {
        heading: "Data & Connectivity Standards",
        description: "Dual serial ports (RS485 full‑/half‑duplex, RS232), CAN Bus, UART, I²C, SPI, USB 2.0, Ethernet RJ45; optional expansion via JTAG and DIP‑switch selectable protocols.",
        position: "bottom"
      },
      {
        heading: "Electrical & Signal Versatility",
        description: "Wide 12–24 V DC input (9–36 V DC tolerant); eight 4–20 mA analog inputs (12‑bit), eight digital inputs and outputs with surge protection.",
        position: "left"
      },
      {
        heading: "Product Build",
        description: "Rugged, fanless design housed in a compact IP54‑rated enclosure; screw‑ or panel‑mountable with optional DIN‑rail adapter.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Analog Inputs:</span>8 x 4–20mA (12-bit resolution)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Digital Inputs/Outputs:</span>  8 DI + 8 DO (configurable)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Supply:</span> 12–24V DC</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Serial Interfaces:</span> RS485, UART, RS232, I2C, SPI, USB </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Network Support:</span> RJ45 Ethernet, CAN Bus </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Temp Range:</span> –20°C to +60°C </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting Options:</span> Screw / Panel / Optional DIN Rail </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Certifications:</span>   CE, FCC, RoHS Compliant </> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Robust Power Flexibility",
        description: "Supports a wide input voltage range (12–24V DC), allowing seamless integration into diverse industrial setups—from factory lines to compact embedded enclosures."
      },
      {
        icon: <Temperature />,
        title: "Industrial-Grade Resilience",
        description: "Built to withstand harsh conditions, including extreme temperatures, vibrations, and electrical noise. Designed for reliable performance in demanding field and embedded environments."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Reliable Connectivity Options",
        description: "Offers a rich set of interfaces including Ethernet, RS485, USB, CAN, UART, I2C, SPI, and RS232—ensuring uninterrupted data exchange in distributed systems and networked applications."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Smart HMI Integration",
        description: "Easily interfaces with external touchscreen HMIs via standard protocols. Ideal for OEMs or developers building intuitive control panels without the need for bulky PLCs."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Features onboard protection circuitry against over-voltage, reverse polarity, and signal surges—ensuring safe and stable operation in critical control applications."
      },
      {
        icon: <InnovationIcon />,
        title: "Multi-System Compatibility",
        description: "Supports integration with microcontrollers, edge devices, industrial PCs, and SCADA systems—making it ideal for Windows, Linux, or real-time operating environments."
      },

    ],
    // ProductImages: [MiniaturemscsGrey],
    ProductImages: [
      { src: MiniaturemscsGrey, colorCode: 1 },
    ],
    specifications: "The InduX Edge 8 offers industrial-grade performance in a compact design. With robust components, built-in protections, and versatile I/O, it's ideal for reliable control in space-constrained, harsh environments.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Powerful Performance',
        desc: 'Intel Core i5 5th Gen Processor with 8GB DDR3 RAM and 256GB SSD built-in.',
      },
      {
        side: 'right',
        text: 'Wide Connectivity',
        desc: '2 x RS485, 1 x RS232, 2 x USB 3.0, 2 x GbE Ethernet, SIM socket, and SMA antenna ports for 4G/Wi-Fi/GPS.',
      },
      {
        side: 'left',
        text: 'Modular Expandability',
        desc: 'PCIe, M.2, and Mini PCIe slots enable future customization and system scaling.',
      },
      {
        side: 'right',
        text: 'Integrated Display',
        desc: '7" Capacitive Touch Screen with 1024x600 resolution for intuitive HMI.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'High-Speed Storage',
        desc: 'Comes with built-in 256GB SSD and provision for mounting 2 external HDDs, ensuring fast data access and scalability.',
      },
      {
        side: 'left',
        text: 'Multi-OS Support',
        desc: 'Compatible with both Windows 10 and Linux distributions for greater flexibility across industrial applications.',
      },
      {
        side: 'right',
        text: 'Industrial Durability',
        desc: 'IP65-rated enclosure, wide input voltage (9–36VDC), and operating range from -20°C to 75°C.',
      },
      {
        side: 'left',
        text: 'Dynamic Power Output',
        desc: 'Wall mount-ready with compact form factor and robust build.',
      }
    ],

    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Enquire Now", key: "enquirenow" },
      { step: 4, label: "Specifications", key: "specifications" },
    ]
  },

  //vidyuraksha 2.0
  {
    IsHoriz: true,
    ProductName: (<span>VidyuRaksha <span style={{ color: 'var(--primary-color)' }}> 2.0</span> </span>),
    ProductDescription: (<>Power, protect, and monitor    <span style={{ color: 'var(--primary-color)' }}>all in one</span> compact, edge-ready device.</>),
    ProductSubText: (<>VidyuRaksha 2.0 is a smart control system built for industrial environments. With high power handling, integrated sensor support, and edge IIoT capabilities, it enables real-time automation and safety like never before.</>),
    ProductFeatureSvg: VidyurakshaKeyFeatures,
    ProductFeatureImageMobile: VidyurakshaKeyFeaturesMobile,
    HomeImage: VidyurakshaKeyHome,
    MobileHomeImage: VidyurakshaKeyHome,
    specificationandwarranty: [
      {
        heading: "Sensor & Control Integration",
        description: "Compatible with temperature, humidity, smoke, access, and surveillance sensors. Offers flexible control via app, manual switch, or scheduled automation.",
        position: "bottom"
      },
      {
        heading: "Environmental Durability",
        description: "Operates reliably in harsh environments with –10°C to 60°C temperature range, 10–90% humidity tolerance, and an industrial-grade flame-retardant ABS enclosure.",
        position: "left"
      },
      {
        heading: "Electrical & Load Capacity",
        description: "Supports 16A / 3600W output with built-in surge, short-circuit, and voltage fluctuation protection for safe, uninterrupted industrial power control.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Voltage:</span> 220–240V AC, 50/60Hz</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Consumption (Idle):</span> less than  1W</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temperature Range:</span>  –10°C to 60°C</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Humidity Tolerance:</span> 10% – 90% RH (non-condensing) </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Material:</span> Industrial-grade Flame-Retardant ABS </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span> Wall mount or DIN rail compatible </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Dimensions:</span> 145mm x 90mm x 50mm </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Weight:</span> 420g</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Status Indicators:</span> LED indicators for power, connectivity, and sensor activity</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Communication Protocols:</span> MQTT, HTTP, WebSocket</> },
    ],


    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Sensor Fusion",
        description: "Consolidates data from multiple sensors into one intelligent control unit."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Scalable & Future-Ready",
        description: " Built for expansion and IIoT adoption across facilities."
      },
      {
        icon: <InnovationIcon />,
        title: "Energy Insights",
        description: "Track real-time and historical energy usage to optimize operations."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Smart Control",
        description: "Control via app, switch, or automation schedules for effortless management."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Advanced encryption and secure Wi-Fi connectivity to block unauthorized access."
      }
    ],
    // ProductImages: [VidhyurakshaGrey],
    ProductImages: [
      { src: VidhyurakshaGrey, colorCode: 1 },
    ],
    specifications: "VidyuRaksha 2.0 is engineered to meet industrial-grade performance and safety standards. Designed for harsh operational environments, it delivers robust automation, high power capacity, secure connectivity, and seamless sensor integration—all within a compact footprint.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'High-Power Handling',
        desc: '16A / 3600W capacity for demanding industrial loads',
      },
      {
        side: 'right',
        text: 'Surge & Short-Circuit Protection',
        desc: 'Built-in safeguards to protect critical equipment',
      },
      {
        side: 'left',
        text: 'Voltage Fluctuation Protection',
        desc: 'Maintains stable output and extends equipment life',
      },
      {
        side: 'right',
        text: 'Universal Sensor Compatibility',
        desc: 'Supports temperature, humidity, smoke, access, and surveillance sensors',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Firmware Over-the-Air Updates',
        desc: 'Continuously improve system performance and security remotely',
      },
      {
        side: 'left',
        text: 'Multi-Control Options',
        desc: 'Operate devices via app, switch, or automated scheduling',
      },
      {
        side: 'right',
        text: 'Edge-Ready for IIoT',
        desc: 'Enables local data processing and seamless IIoT integration',
      },
      {
        side: 'left',
        text: 'Real-Time Alerts & Smart Automation',
        desc: 'Trigger actions and receive alerts based on live sensor data',
      }
    ],
    ProductCatalog: [
      {
        f1: "Intelligent Control",
        f2: "Power Secured",
        image: Vidhyurakshacatalog1
      },
      {
        f1: "Sensor Ready",
        f2: "Real-Time Alerts",
        image: Vidhyurakshacatalog2
      },
      {
        f1: "Edge Enabled",
        f2: "Smart Safety",
        image: Vidhyurakshacatalog3
      },
      {
        f1: "Energy Insights",
        f2: "App Controlled",
        image: Vidhyurakshacatalog4
      },
    ],

    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog and WebApp", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],

    WebApplicationModel: {
      section: {
        features1: "Multiple users can securely access and control the smart panel from different devices, ensuring seamless power management across teams or shared spaces.",
        features2: "Turn your applicances on/off, track energy use, and set schedules—all from a single screen.",
        features3: "Instantly share control with service providers for diagnostics and remote support.",
        idealLargeScreens: {
          title: "Ideal for Large Screens",
          description: "Dashboard view with detailed insights, graphs, and controls, optimized for desktops."
        },
        multiDeviceSync: {
          title: "Multi-Device Sync",
          description: "Your preferences, schedules, and usage data are always in sync across mobile and desktop."
        },
        image1: VidhyurakshaWebApplication1,
        image2: VidhyurakshaWebApplication2
      }
    },

  },

  //water quality board (or) Compact Multi Sensor Industrial Control System

  {
    IsHoriz: true,
    ProductName: (<span>SensiConnect <span style={{ color: 'var(--primary-color)' }}> <br />1612 PRO</span> </span>),
    ProductDescription: (<>Compact, Intelligent <span style={{ color: 'var(--primary-color)' }}>Control & Monitoring</span></>),
    ProductSubText: (<>This powerful system delivers streamlined industrial automation in a compact form. Perfectly crafted for environments demanding multi-sensor feedback, real-time edge processing, robust connectivity, and rapid deployment all in one seamless solution.</>),
    ProductFeatureSvg: WaterQulaityBoardKeyFeatures,
    ProductFeatureImageMobile: WaterQulaityBoardKeyFeaturesMobile,
    HomeImage: WaterQulaityBoardHome,
    MobileHomeImage: WaterQulaityBoardHome,
    specificationandwarranty: [
      {
        heading: "Data & Connectivity Standards",
        description: "Rugged plastic design housed in precision-molded enclosure. Supports vertical or horizontal DIN rail and surface-mount deployments",
        position: "bottom"
      },
      {
        heading: "Electrical & Signal Versatility",
        description: "16× 4–20mA analog inputs with resolution control. 12-bit digital inputs and outputs with surge protection",
        position: "left"
      },
      {
        heading: "Product Build",
        description: "Rugged plastic design housed in precision-molded enclosure. Supports vertical or horizontal DIN rail and surface-mount deployments",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Analog Inputs:</span> 16 × 4–20mA (12-bit resolution)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Digital I/Os:</span> 8 DI / 8 DO (configurable)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Supply:</span> 12–24V DC</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Serial Interfaces:</span> RS485, UART, RS232, I2C, SPI, USB</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Network Support:</span> RJ45 Ethernet, CAN Bus</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Temp Range:</span> –20°C to +70°C</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting Options:</span> Screw / Panel / DIN Rail (Optional)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Certifications:</span> CE, FCC, RoHS Compliant</> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Robust Power Flexibility",
        description: "Wide input voltage, surge protection, and load control support for demanding use cases."
      },
      {
        icon: <Temperature />,
        title: "Industrial-Grade Resilience",
        description: "Built to operate in harsh environments with wide operating temperatures and IP-rated enclosure."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Reliable Connectivity Options",
        description: "Native support for RS485 FD/HD, Ethernet, CAN, USB and optional BLE/Wi-Fi/LTE integration."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Smart HMI Integration",
        description: "Option to add display with live diagnostics, system info, and calibration tools."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Hardware watchdog, reverse polarity protection, and fault-tolerant circuit design."
      },
      {
        icon: <InnovationIcon />,
        title: "Multi-System Compatibility",
        description: "Supports Modbus RTU/TCP, MQTT, Profinet, EtherNet/IP — plug & play in existing setups."
      },

    ],
    // ProductImages: [WaterQulaityBoardGrey],
    ProductImages: [
      { src: WaterQulaityBoardGrey, colorCode: 1 },
    ],
    specifications: "The SensiConnect 1612 PRO offers Industrial-Grade Performance in a Compact Design. With Robust Components, Built-In Protections, and Versatile I/O, it’s ideal for reliable control in space-constrained, harsh environments.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Flexible Mounting Options',
        desc: 'Easily installable in compact or embedded control panels with multiple orientation support.',
      },
      {
        side: 'right',
        text: 'Ultra-Compact Footprint',
        desc: 'Designed for dense installations while maintaining full accessibility and thermal efficiency.',
      },
      {
        side: 'left',
        text: 'Wide Voltage Range Support',
        desc: 'From 12V–24V DC (typical) and up to 36V max with protection  ensures flexible deployment.',
      },
      {
        side: 'right',
        text: '16× 4–20mA Analog Inputs',
        desc: 'Industry-standard current loop support for high-accuracy industrial sensors.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Multiple Communication Interfaces',
        desc: 'RJ45, RS485, UART, SPI, USB, CAN  with expansion-ready options for LTE/WiFi.',
      },
      {
        side: 'left',
        text: 'JTAG & DIP Switch Configurations',
        desc: 'Flexible developer mode, hardware-level debugging, and field-level reconfiguration.',
      },
      {
        side: 'right',
        text: '8× Digital Inputs & 8× Digital Outputs',
        desc: '8× Digital Inputs & 8× Digital OutputsVersatile I/O capability for controlling relays, actuators, or logic-driven automation.',
      },
      {
        side: 'left',
        text: 'Flexible Mounting Options',
        desc: 'Rugged casing with built-in ESD protection, power surge tolerance, and EMI shielding.',
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Enquire Now", key: "enquirenow" },
      { step: 4, label: "Specifications", key: "specifications" },
    ],


  },
//RugEdge V3000
  // {
  //   IsHoriz: true,
  //   ProductName: (<span>RugEdge  <span style={{ color: 'var(--primary-color)' }}> V3000</span> </span>),
  //   ProductDescription: (<>Rugged. Reliable.  <span style={{ color: 'var(--primary-color)' }}>Ready.</span></>),
  //   ProductSubText: (<>A next-generation ruggedized edge computer powered by AMD Ryzen™ Embedded V3C18I, engineered for mission-critical performance in the harshest environments — from industrial automation to defense, robotics, and railways.</>),
  //   ProductFeatureSvg: RugEdge_v3000Features,
  //   ProductFeatureImageMobile: RugEdge_v3000FeaturesMobile,

  //   HomeImage: RugEdge_v3000HomePage,
  //   MobileHomeImage: RugEdge_v3000HomePage,
  //   specificationandwarranty: [

  //   ],
  //   ProductDetails: [
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Processor:</span> AMD Ryzen™ Embedded V3C18I with up to 8 cores for high-performance edge computing</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Memory & Storage:</span> DDR4 / LPDDR5 support and M.2 NVMe SSD options</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Connectivity:</span> Dual 10 Gb Ethernet, LTE/GPS/Wi-Fi/BLE, USB 3.2, RS-485, CAN, GPIO, and COM interfaces</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Thermal & Environmental:</span> Fanless heat-dissipating design, –40°C to 85°C operating range, rugged vibration-resistant enclosure</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Protection:</span>  EMI/ESD shielding, high/low-voltage protection, and integrated threat detection</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power:</span>  Wide input voltage range with intelligent current protection</> },
  //   ],


  //   ProductCatalog: [
  //     {
  //       f1: "Rugged Build",
  //       f2: "Stable Connectivity",
  //       image: RugEdge_v3000catalog1
  //     },
  //     {
  //       f1: "Global Compatibility",
  //       f2: "Wide Voltage Support",
  //       image: RugEdge_v3000catalog2
  //     },
  //     {
  //       f1: " Next-Gen Performance",
  //       f2: "Sleek Industrial Design",
  //       image: RugEdge_v3000catalog3
  //     },
  //     {
  //       f1: "Auto Diagnostics",
  //       f2: "Button-Free Operation",
  //       image: RugEdge_v3000catalog4
  //     },

  //   ],



  //   AltProductSolutions: RugEdge_v3000_Solutions,
  //   AltProductSolutionsMobile: RugEdge_v3000_SolutionsMobile,
  //   // ProductImages: [RugEdge_v3000_blue],
  //   ProductImages: [
  //     { src: RugEdge_v3000_blue, colorCode: 5 },
  //   ],
  //   specifications: "The SensiConnect 1612 PRO offers Industrial-Grade Performance in a Compact Design. With Robust Components, Built-In Protections, and Versatile I/O, it’s ideal for reliable control in space-constrained, harsh environments.",
  //   partners: [{ svg: Rohs }, { svg: Ce }],
  //   topBranches: [

  //     {
  //       side: 'right',
  //       text: 'Fanless Architecture',
  //       desc: 'Silent, dust-proof design supporting –40°C to 85°C operations.',

  //     },
  //     {
  //       side: 'left',
  //       text: 'Intelligent Health Monitoring',
  //       desc: 'Continuous diagnostics ensure reliable long-term mission-critical performance.',
  //     },
  //     {
  //       side: 'right',
  //       text: 'Comprehensive Wireless Connectivity',
  //       desc: 'LTE, GPS, Wi-Fi, and Bluetooth for seamless multi-network communication.',
  //     },
  //   ],
  //   bottomBranches: [
  //     {
  //       side: 'right',
  //       text: 'Precision Thermal Management',
  //       desc: 'Built-in sensors deliver real-time temperature control and adaptive cooling.',
  //     },
  //     {
  //       side: 'left',
  //       text: 'Dual 10 Gb Ethernet',
  //       desc: 'Multi-speed support (1 / 2.5 / 10 Gbps) for ultra-fast data throughput.',
  //     },
  //     {
  //       side: 'right',
  //       text: 'EMI/ESD Shielding',
  //       desc: 'Protection against electromagnetic interference and static discharge.',
  //     }
  //   ],


  //   steps: [
  //     { step: 1, label: "Key Features", key: "features" },
  //     { step: 2, label: "Solutions", key: "solutions" },
  //     { step: 3, label: "Product Catalog", key: "catalog" },
  //     { step: 4, label: "Enquire Now", key: "enquirenow" },
  //     // { step: 5, label: "Specifications", key: "specifications" },
  //   ],


  // },

  // RugEdge R8000

  //  {
  //   IsHoriz: true,
  //   ProductName: (<span>RugEdge  <span style={{ color: 'var(--primary-color)' }}> R8000</span> </span>),
  //   ProductDescription: (<>Rugged Intelligence at the   <span style={{ color: 'var(--primary-color)' }}>Edge</span></>),
  //   ProductSubText: (<>A rugged, high-performance industrial edge computer designed for AI, automation, robotics, and mission-critical applications.</>),
  //   ProductFeatureSvg: RugEdge_r8000Features,
  //   ProductFeatureImageMobile: RugEdge_v3000FeaturesMobile,

  //   HomeImage: RugEdge_r8000HomePage,
  //   MobileHomeImage: RugEdge_r8000HomePage,
  //   specificationandwarranty: [

  //   ],
  //   ProductDetails: [
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Processor:</span> AMD Ryzen™ Embedded V3C18I with up to 8 cores for high-performance edge computing</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Memory & Storage:</span> DDR4 / LPDDR5 support and M.2 NVMe SSD options</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Connectivity:</span> Dual 10 Gb Ethernet, LTE/GPS/Wi-Fi/BLE, USB 3.2, RS-485, CAN, GPIO, and COM interfaces</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Thermal & Environmental:</span> Fanless heat-dissipating design, –40°C to 85°C operating range, rugged vibration-resistant enclosure</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Protection:</span>  EMI/ESD shielding, high/low-voltage protection, and integrated threat detection</> },
  //     { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power:</span>  Wide input voltage range with intelligent current protection</> },
  //   ],



  //   ProductCatalog: [
  //     {
  //       f1: "Rugged Build",
  //       f2: "Stable Connectivity",
  //       image: RugEdge_r8000catalog1
  //     },
  //     {
  //       f1: "Global Compatibility",
  //       f2: "Wide Voltage Support",
  //       image: RugEdge_r8000catalog2
  //     },
  //     {
  //       f1: " Next-Gen Performance",
  //       f2: "Sleek Industrial Design",
  //       image: RugEdge_r8000catalog3
  //     },
  //     {
  //       f1: "Auto Diagnostics",
  //       f2: "Button-Free Operation",
  //       image: RugEdge_r8000catalog4
  //     },

  //   ],



  //   AltProductSolutions: RugEdge_r8000_Solutions,
  //   AltProductSolutionsMobile: RugEdge_r8000_SolutionsMobile,
  //   // ProductImages: [RugEdge_v3000_blue],
  //   ProductImages: [
  //     { src: RugEdge_r8000_black, colorCode: 6 },
  //   ],
  //   specifications: "The SensiConnect 1612 PRO offers Industrial-Grade Performance in a Compact Design. With Robust Components, Built-In Protections, and Versatile I/O, it’s ideal for reliable control in space-constrained, harsh environments.",
  //   partners: [{ svg: Rohs }, { svg: Ce }],
  //   topBranches: [

  //     {
  //       side: 'right',
  //       text: 'Fanless Architecture',
  //       desc: 'Silent, dust-proof design supporting –40°C to 85°C operations.',

  //     },
  //     {
  //       side: 'left',
  //       text: 'Intelligent Health Monitoring',
  //       desc: 'Continuous diagnostics ensure reliable long-term mission-critical performance.',
  //     },
  //     {
  //       side: 'right',
  //       text: 'Comprehensive Wireless Connectivity',
  //       desc: 'LTE, GPS, Wi-Fi, and Bluetooth for seamless multi-network communication.',
  //     },
  //   ],
  //   bottomBranches: [
  //     {
  //       side: 'right',
  //       text: 'Precision Thermal Management',
  //       desc: 'Built-in sensors deliver real-time temperature control and adaptive cooling.',
  //     },
  //     {
  //       side: 'left',
  //       text: 'Dual 10 Gb Ethernet',
  //       desc: 'Multi-speed support (1 / 2.5 / 10 Gbps) for ultra-fast data throughput.',
  //     },
  //     {
  //       side: 'right',
  //       text: 'EMI/ESD Shielding',
  //       desc: 'Protection against electromagnetic interference and static discharge.',
  //     }
  //   ],


  //   steps: [
  //     { step: 1, label: "Key Features", key: "features" },
  //     { step: 2, label: "Solutions", key: "solutions" },
  //     { step: 3, label: "Product Catalog", key: "catalog" },
  //     { step: 4, label: "Enquire Now", key: "enquirenow" },
  //   ],


  // },

  //Industrial Rugged 16-Port L2 Managed Switch
  {
    IsHoriz: true,
    ProductName: (<span>Industrial Rugged 16-Port L2  <span style={{ color: 'var(--primary-color)' }}> Managed Switch</span></span>),
    ProductDescription: (<>Unwavering Connectivity for Mobile & Harsh Industrial  <span style={{ color: 'var(--primary-color)' }}>Environments</span></>),
    ProductSubText: (<>A high-performance, Made-in-India 16-Port Gigabit Ethernet Switch with PoE+ and Fiber Uplinks, designed for vibration-prone, high-EMI, and outdoor applications. Ideal for smart factories, public transport, and mission-critical edge deployments.</>),
    ProductFeatureSvg: Port16ManagedSwitchKeyFeatures,
    ProductFeatureImageMobile: Port16ManagedSwitchKeyFeaturesMobile,
    HomeImage: Port16ManagedSwitchHome,
    MobileHomeImage: Port16ManagedSwitchHome,
    specificationandwarranty: [
      {
        heading: "Protection & Build Quality",
        description: "Fanless aluminum housing with IP67-rated M12 connectors and IP40 casing delivers dustproof, water-resistant performance in outdoor and industrial use cases.",
        position: "bottom"
      },
      {
        heading: "Advanced Network Management",
        description: "Supports VLAN, QoS, IGMP Snooping, Link Aggregation, STP/MSTP, with Web GUI, CLI, and SNMP—offering full control and visibility into network performance.",
        position: "left"
      },
      {
        heading: "Robust Power Architecture",
        description: "Dual redundant 24/48 VDC inputs (optionally up to 110 VDC) ensure seamless power failover and uninterrupted switch operation in critical infrastructure.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ethernet Ports:</span> 16 x 10/100/1000Base-T(X), M12, PoE/PoE+</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Fiber Ports:</span> 2 x 1000Base-X SFP Slots</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>PoE Standards:</span> IEEE 802.3af/at (Up to 30W per port)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span> Dual 24/48 VDC (Optional: 24–110 VDC)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Switch Type:</span> Layer 2 Managed</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Management:</span> Web GUI, CLI, SNMP, Port Mirroring</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>L2 Features:</span>  VLAN, QoS, IGMP, STP, MSTP, LACP</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Temperature Range:</span>  -40°C to +75°C</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ingress Protection: </span>  M12 Ports: IP67, Casing: IP40</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Shock/Vibration: </span>  IEC 61373, EN 60068-2-27/6</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Certifications: </span>   CE, FCC, EN 50121-3-2</> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Redundant Power Supply",
        description: "Dual DC inputs eliminate single-point failure."
      },
      {
        icon: <Temperature />,
        title: "Extreme Operating Temperature Support",
        description: "Performs reliably in -40°C to +75°C conditions."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Uninterrupted Uplink Communication",
        description: "Dual fiber uplinks ensure stable backbone even in EMI-heavy environments."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Full L2 Management Suite",
        description: "Intuitive GUI & CLI with advanced protocols for traffic optimization."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "IP67 M12 connectors and IP40 rugged casing provide strong protection against dust, water, and harsh environments ideal for industrial and outdoor use."
      },
      {
        icon: <InnovationIcon />,
        title: "High-Density Industrial Connectivity",
        description: "16 secure M12 PoE ports for IP cameras, sensors & more"
      },

    ],
    // ProductImages: [Port16ManagedSwitchGrey],
    ProductImages: [
      { src: Port16ManagedSwitchGrey, colorCode: 1 },
    ],
    specifications: "The Industrial Rugged 16-Port L2 Managed Switch is built for extreme industrial and mobile environments, offering reliable performance in high-vibration, high-EMI, and wide-temperature conditions. Proudly made in India, it ensures long-term durability, advanced network control, and certified mission-critical connectivity.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: '16 x Gigabit M12 Ports',
        desc: 'Vibration-proof and waterproof Ethernet with secure power delivery',
      },
      {
        side: 'right',
        text: '2 x 1G Fiber Uplinks',
        desc: 'EMI-immune, long-range connectivity for robust network backbones',
      },
      {
        side: 'left',
        text: 'Advanced Layer 2 Management',
        desc: 'Full L2 suite including VLAN, QoS, IGMP and LACP',
      },
      {
        side: 'right',
        text: 'Redundant Power Inputs',
        desc: 'Dual DC inputs for uninterrupted power and maximum uptime',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Rugged Fanless Construction',
        desc: 'No moving parts; ideal for dusty, high-vibration environments',
      },
      {
        side: 'left',
        text: 'Wide Operating Temperature Range',
        desc: 'Reliable performance from -40°C to +75°C for extreme conditions',
      },
      {
        side: 'right',
        text: 'Industrial Certifications & Standards',
        desc: 'Complies with IEC, EN, and EMC standards for mobile/industrial use',
      },
      {
        side: 'left',
        text: 'Designed & Made in India',
        desc: 'Indigenous design, robust quality control, and local support',
      }
    ],

    ProductCatalog: [
      {
        f1: "Multi-Port Power",
        f2: "Industrial-Grade Design",
        image: Port16ManagedSwitchcatalog1
      },
      {
        f1: "Fiber-Backbone Ready",
        f2: "Data-Secure Build",
        image: Port16ManagedSwitchcatalog2
      },
      {
        f1: "Compact & Efficient",
        f2: "Fanless Cooling",
        image: Port16ManagedSwitchcatalog3
      },
      {
        f1: "Built for Extremes",
        f2: "Shock & Vibration Resistant",
        image: Port16ManagedSwitchcatalog4
      },
      {
        f1: "Consistent Throughput",
        f2: "Low Latency Networking",
        image: Port16ManagedSwitchcatalog5
      },
      {
        f1: "Precision M12 Ports",
        f2: "Rugged Metal Housing",
        image: Port16ManagedSwitchcatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],


  },

  //Industrial Rugged 16-Port UnManaged Switch
  {
    IsHoriz: true,
    ProductName: (<span>Industrial Rugged 16-Port <span style={{ color: 'var(--primary-color)' }}> Unmanaged Switch</span></span>),
    ProductDescription: (<>Instant <span style={{ color: 'var(--primary-color)' }}> Power & Data</span> . Engineered for Extreme Industrial Applications. </>),
    ProductSubText: (<>Delivering plug-and-play simplicity with uncompromising reliability, this 16-port M12 Ethernet switch is purpose-built for mobile and harsh industrial environments. Designed and manufactured in India, it’s your go-to solution for powering and connecting critical systems via PoE+—all with zero configuration.</>),
    ProductFeatureSvg: Port16UnManagedSwitchKeyFeatures,
    ProductFeatureImageMobile: Port16UnManagedSwitchKeyFeaturesMobile,
    HomeImage: Port16UnManagedHome,
    MobileHomeImage: Port16UnManagedHome,
    specificationandwarranty: [
      {
        heading: "Robust Power Architecture",
        description: "Dual redundant 24/48 VDC inputs (with optional 24–110 VDC support) ensure uninterrupted uptime and power failover protection in demanding environments.",
        position: "bottom"
      },
      {
        heading: "Protection & Build Quality",
        description: "Fanless aluminum body with IP67-rated M12 connectors and IP40 enclosure guarantees dustproof, water-resistant durability across harsh industrial and outdoor conditions.",
        position: "left"
      },
      {
        heading: "Zero-Config Plug & Play",
        description: "Unmanaged operation allows instant deployment without software setup. Ideal for distributed and low-maintenance industrial networks.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ethernet Ports:</span> 16 x 10/100/1000Base-T(X), M12 D-coded, PoE/PoE+ PoE</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Budget:</span>  Up to XXXW total (model dependent)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span>  Dual 24/48 VDC</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Switch Type:</span>  Unmanaged, Plug & Play</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span>  Wall Mount / DIN-Rail Compatible</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Housing:</span>  Fanless Aluminum, Industrial Grade</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ingress Protection:</span>  M12 Ports: IP67 | Casing: IP40</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Shock/Vibration:</span>  IEC 61373 (Cat 1, Class B), EN 60068-2-27/6 </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>EMC Compliance:</span>  EN 50121-3-2, EN 61000-6-2/4, FCC Part 15, CE </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Humidity:</span>  5% – 95% RH </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Origin:</span>  Designed & Made in India </> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Redundant Power Supply",
        description: "Power and connect IP cameras, sensors, and control units through a single cable—up to 30W per port."
      },
      {
        icon: <Temperature />,
        title: "Extreme Operating Temperature Support",
        description: "Certified for shock, vibration, EMI, and wide temperature ranges."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Redundant Power Input",
        description: "Keeps your system running even if one power source fails."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Plug & Play Deployment",
        description: "Zero configuration required connect devices and go."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Shielded against dust, moisture, and electrical surges for long-term durability."
      },
      {
        icon: <InnovationIcon />,
        title: "Maintenance-Free",
        description: "Truly unmanaged ideal for distributed systems and remote deployments."
      },

    ],
    // ProductImages: [Port16unmanagedGrey],
    ProductImages: [
      { src: Port16unmanagedGrey, colorCode: 1 },
    ],
    specifications: "The Industrial Rugged 16-Port Unmanaged PoE+ M12 Switch is designed for extreme industrial and mobile deployments, ensuring zero-configuration, high-reliability performance under shock, vibration, EMI, and wide temperature fluctuations. Proudly made in India, it combines robust power design, mechanical durability, and industry-grade certifications for mission-critical connectivity.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: '16x M12 PoE+ Ports',
        desc: 'Gigabit M12 ports with PoE+ (IEEE 802.3at) – up to 30W per port.Gigabit M12 ports with PoE+ (IEEE 802.3at) – up to 30W per port.',
      },
      {
        side: 'right',
        text: 'Plug & Play',
        desc: 'No setup needed. Just connect and power up.',
      },
      {
        side: 'left',
        text: 'Rugged Connectors',
        desc: 'Vibration-proof M12 for mobile and harsh use.',
      },
      {
        side: 'right',
        text: 'Wide Temp Range',
        desc: 'Operates from -40°C to +75°C without fail.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Dual Power Input',
        desc: 'Redundant DC input for nonstop uptime.',
      },
      {
        side: 'left',
        text: 'Fanless Metal Body',
        desc: 'P40-rated aluminum housing for durability.',
      },
      {
        side: 'right',
        text: 'Certified Rugged',
        desc: 'Tested for shock, vibration, EMI, and more.',
      },
      {
        side: 'left',
        text: 'Designed & Made in India',
        desc: 'Indigenous design, robust quality control, and local support',
      }
    ],

    ProductCatalog: [
      {
        f1: "Multi-Port Power",
        f2: "Industrial-Grade Design",
        image: Port16UnManagedSwitchcatalog1
      },
      {
        f1: "Fiber-Backbone Ready",
        f2: "Data-Secure Build",
        image: Port16UnManagedSwitchcatalog2
      },
      {
        f1: "Compact & Efficient",
        f2: "Fanless Cooling",
        image: Port16UnManagedSwitchcatalog3
      },
      {
        f1: "Built for Extremes",
        f2: "Shock & Vibration Resistant",
        image: Port16UnManagedSwitchcatalog4
      },
      {
        f1: "Stable Throughput",
        f2: "Low Latency Networking",
        image: Port16UnManagedSwitchcatalog5
      },
      {
        f1: "Precision M12 Ports",
        f2: "Rugged Metal Housing",
        image: Port16UnManagedSwitchcatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],


  },

  //Industrial Rugged 8-Port L2 Managed Switch
  {

    IsHoriz: true,
    ProductName: (<span>Industrial Rugged 8-Port L2  <span style={{ color: 'var(--primary-color)' }}> Managed Switch</span></span>),
    ProductDescription: (<>Unwavering   <span style={{ color: 'var(--primary-color)' }}> Connectivity</span> for Mobile & Harsh Industrial Environments</>),
    ProductSubText: (<>A compact yet powerful switch engineered for performance in the most demanding environments. Featuring 8 Gigabit M12 PoE+ ports and 2 Fiber uplinks, it guarantees seamless communication even in the face of vibration, shock, and EMI. Built in India for the future of industrial networking.</>),
    ProductFeatureSvg: Port8ManagedSwitchKeyFeatures,
    ProductFeatureImageMobile: Port8ManagedSwitchKeyFeaturesMobile,
    HomeImage: Port8ManagedHome,
    MobileHomeImage: Port8ManagedHome,
    specificationandwarranty: [
      {
        heading: "Advanced Layer 2 Management",
        description: "VLANs, QoS, IGMP, Link Aggregation, and Network Bypass with intuitive GUI, CLI, and SNMP support.",
        position: "bottom"
      },
      {
        heading: "Robust Power Architecture",
        description: "Dual 24/48 VDC inputs (optional 24–110 VDC) ensure uninterrupted power and failover protection.",
        position: "left"
      },
      {
        heading: "Protection & Build Quality",
        description: "Rugged fanless aluminum body with IP67 M12 connectors and IP40 casing for dust, water, and vibration resistance.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ethernet Ports:</span> 8 x 10/100/1000Base-T(X), M12 D-coded, PoE/PoE+</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Fiber Uplinks:</span>  2 x 1000Base-X SFP Slots</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span>  Dual 24/48 VDC (Optional: 24–110 VDC)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Input:</span>  Layer 2 Managed</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Management:</span>  Web GUI, CLI, SNMP v1/v2c/v3, RMON, Port Mirroring</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Shock/Vibration:</span>  IEC 61373 (Cat 1, Class B), EN 60068-2-27/6</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>EMC Compliance:</span> EN 50121-3-2, EN 61000-6-2/4, FCC Part 15, CE</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Humidity:</span> 5% – 95% RH </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temperature:</span>  -40°C to +75°C </> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Origin:</span>   Designed & Made in India </> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Redundant Power Supply",
        description: "Dual 24/48 VDC input range for maximum uptime."
      },
      {
        icon: <Temperature />,
        title: "Extreme Operating Temperature Support",
        description: "Wide range of -40°C to +75°C, ideal for outdoor/mobile environments."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Advanced L2 Control",
        description: "VLANs, QoS, Network Bypass, and Link Aggregation."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Production-Ready",
        description: "Fanless, dustproof, vibration-proof engineered for continuous uptime."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "IP67-rated M12 ports and rugged aluminum housing ensure complete environmental shielding perfect for mission-critical applications in the toughest conditions."
      },
      {
        icon: <InnovationIcon />,
        title: "High-Performance Industrial & Mobile Networks",
        description: "Reliable M12 and fiber uplink-based design for future-ready networking."
      },

    ],

    // ProductImages: [Port8ManagedGrey],
    ProductImages: [
      { src: Port8ManagedGrey, colorCode: 1 },
    ],
    specifications: "The Industrial Rugged 8-Port L2 Managed PoE+ M12 Switch delivers robust Layer 2 control and reliable performance in extreme industrial and mobile environments. Built in India, it ensures seamless data transmission, power redundancy, and protection against shock, vibration, and EMI.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: '8 x Gigabit M12 PoE/PoE+ Ports',
        desc: 'Secure, shock-resistant M12 connectors ideal for vibration-prone setups like transportation and heavy equipment.',
      },
      {
        side: 'right',
        text: '2 x 1G Fiber Uplink Ports',
        desc: 'Supports long-distance communication with EMI-immunity.',
      },
      {
        side: 'left',
        text: 'Advanced Layer 2 Management',
        desc: 'Supports VLANs, QoS, IGMP Snooping, Link Aggregation, and Network Bypass.',
      },
      {
        side: 'right',
        text: 'Network Bypass Functionality',
        desc: 'Maintains data flow during power loss or failure on designated ports.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Redundant Power Input',
        desc: 'Dual DC inputs (24/48 VDC or optional 24–110 VDC) for high availability.',
      },
      {
        side: 'left',
        text: 'Rugged Fanless Construction',
        desc: 'Aluminum alloy casing with wide -40°C to +75°C temperature tolerance.',
      },
      {
        side: 'right',
        text: 'IP67 M12 Interface Protection',
        desc: 'Waterproof, dustproof connectors ideal for harsh industrial and mobile settings.',
      },
      {
        side: 'left',
        text: 'Designed & Made in India',
        desc: 'Indigenous design, robust quality control, and local support',
      }
    ],

    ProductCatalog: [
      {
        f1: "Compact Yet Powerful",
        f2: "PoE+ Over Secure M12",
        image: Port8ManagedSwitchcatalog1
      },
      {
        f1: "Fiber Uplink Ready",
        f2: "Engineered for Performance",
        image: Port8ManagedSwitchcatalog2
      },
      {
        f1: "Precision M12 Connectors",
        f2: "Efficient Power & Data Delivery",
        image: Port8ManagedSwitchcatalog3
      },
      {
        f1: "Shockproof Construction",
        f2: "Made for Mobile & Rail",
        image: Port8ManagedSwitchcatalog4
      },
      {
        f1: "Fanless, Silent Operation",
        f2: "Extreme Temperature Tolerance",
        image: Port8ManagedSwitchcatalog5
      },
      {
        f1: "DIN-Rail / Wall Mountable",
        f2: "Heavy-Duty Aluminum Housing",
        image: Port8ManagedSwitchcatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],
  },

  //Industrial Rugged 24-Port L2 Managed Switch
  {
    IsHoriz: true,

    ProductName: (<span>Industrial Rugged 24-Port <span style={{ color: 'var(--primary-color)' }}> Managed Switch</span></span>),
    ProductDescription: (<> Heavy‑Duty Use — X‑coded M12, 10 Gb Copper/Fiber, IEC 61375 & 62443, IP68,   <span style={{ color: 'var(--primary-color)' }}> Redundant Power</span></>),
    ProductSubText: (<>The Industrial Rugged 24‑Port 10 Gb/s M12 PoE++ Switch delivers rugged, high-power performance with 24 X‑coded Gigabit M12 PoE/PoE++ ports (90 W each), 4×10 Gb/s M12 + 2×10 Gb/s SFP+ uplinks with ring redundancy, built-in IEC 61375‑3‑4/‑2‑5 (TTDP/TRDP) for automatic train topology, and an IP68-rated chassis with secure boot, tamper detection, and IEC 62443‑4 cybersecurity engineered for harsh industrial and rail environments.</>),
    ProductFeatureSvg: Port24ManagedSwitchKeyFeatures,
    ProductFeatureImageMobile: Port24ManagedSwitchKeyFeaturesMobile,
    HomeImage: Port24ManagedSwitchHome,
    MobileHomeImage: Port24ManagedSwitchHome,
    specificationandwarranty: [
      {
        heading: "Advanced Layer 2 Management",
        description: "Rich feature set including VLANs, QoS, IGMP snooping, link aggregation, and fast network bypass through ERPS/RSTP ensures efficient, prioritized traffic and sub‑30ms recovery",
        position: "bottom"
      },
      {
        heading: "Robust Power Architecture",
        description: "Dual isolated 24–48 V DC inputs (optional 24–110 V DC) ensure uninterrupted operation—even if one power source fails—providing critical resiliency for mission‑critical applications",
        position: "left"
      },
      {
        heading: "Protection & Build Quality",
        description: "Fan‑less aluminum chassis with IP67/68‑rated X‑coded M12 ports and IP40 housing shields against dust, water, shock, and vibration—eliminating the need for external enclosures",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Ethernet Ports:</span> 24 × GbE M12 PoE/PoE++, 4 × 10G M12, 2 × 10G SFP+</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>PoE Power:</span> IEEE 802.3bt Type 4 (max 90 W/port), ~480 W total</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Switching:</span> L2 (VLAN, QoS, ERPS), L3 (OSPF, RIP, VRRP)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Management:</span>  HTTP/S GUI, CLI, SNMP v1/2c/3, RMON, SSH/Telnet</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Rail Certifications:</span>  EN 50155/50121/45545, IEC 61373</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Train Protocols:</span>  IEC 61375‑3‑4/‑2‑5 TTDP/TRDP</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Security:</span>  IEC 62443‑4, secure boot, ACLs, 802.1X, tamper detection</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Environment:</span>  IP68, –40° to +75 °C, dual DC 24‑110 V</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span>  Wall/panel mountable aluminum chassis</> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Redundant Power Supply",
        description: "Dual isolated DC inputs means continuous operation—even if one power source fails, the switch stays online for critical uptime"
      },
      {
        icon: <Temperature />,
        title: "Extreme Operating Temperature Support",
        description: "Rated for –40 °C to +75 °C (or higher), the switch remains reliable in freezing cold or scorching heat—perfect for outdoor and rail applications"
      },
      {
        icon: <ConvenienceIcon />,
        title: "Advanced L2 Control",
        description: "Equipped with VLAN, QoS, IGMP snooping, link aggregation, ERPS/RSTP, and more—this ensures efficient, prioritized traffic flow and network segmentation"
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Production-Ready",
        description: "Fanless, vibration-resistant unit with rugged M12 connectors and aluminum housing—built to work maintenance-free in harsh industrial and railway environments"
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "An IP68-rated chassis and sealed M12 ports provide top-level protection against dust and water, eliminating the need for additional enclosures in extreme field conditions"
      },
      {
        icon: <InnovationIcon />,
        title: "High-Performance Industrial & Mobile Networks",
        description: "Featuring 10 Gb/s uplinks over copper and fiber with ring redundancy protocols, this switch offers a robust, future-proof backbone for data-heavy and mobile industrial networks"
      },

    ],

    // ProductImages: [Port24ManagedGrey],
    ProductImages: [
      { src: Port24ManagedGrey, colorCode: 1 },
    ],
    specifications: "Energized for the toughest rail and industrial missions, this Industrial Rugged 24‑Port 10 Gb/s Managed M12 PoE++ Ethernet Switch delivers uncompromised Layer 2/3 control, uninterrupted power, and iron‑clad protection—guaranteeing reliable performance in extreme environments:",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'High‑Density PoE++ Ports',
        desc: '24 X‑coded M12 ports delivering up to 90 W each for powering HD cameras, Wi‑Fi APs, and sensors.',
      },
      {
        side: 'right',
        text: '10 Gb/s Uplinks & Redundancy',
        desc: 'Four copper and two fiber 10 Gb ports with ERPS/RSTP ring support for ultra-reliable backbone failover.',
      },
      {
        side: 'left',
        text: 'Train‑Standard Integration',
        desc: 'Native IEC 61375 ECN/TBN support with TTDP/TRDP for automatic topology detection and IP assignment.',
      },
      {
        side: 'right',
        text: 'Advanced Layer 2/3 Switching',
        desc: 'Full suite of VLAN, QoS, IGMP snooping, OSPF, RIP, and VRRP, managed via GUI, CLI, or SNMP',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Rugged IP68 Enclosure',
        desc: 'Aluminum housing rated IP68 (comparable IP67/54 options), temperature range –40 °C to +75 °C for harsh outdoor use.',
      },
      {
        side: 'left',
        text: 'Dual Redundant Power',
        desc: 'Wide-voltage, isolated dual DC inputs ensure uninterrupted operation in mission-critical environments',
      },
      {
        side: 'right',
        text: 'Cyber‑Secure by Design',
        desc: 'IEC 62443‑4 certified with secure boot and physical tamper detection for industrial cybersecurity compliance.',
      },
      {
        side: 'left',
        text: 'Robust Railway Certification',
        desc: 'EN 50155, EN 45545, IEC 61373 compliance ensures safety and resistance to shock, vibration, and fire in rail systems',
      }
    ],

    ProductCatalog: [
      {
        f1: "PoE Powerhouse",
        f2: "Rugged Compact Design",
        image: Port24ManagedSwitchcatalog1
      },
      {
        f1: "10 Gb Uplink Ready",
        f2: "Ring-Resilient Network",
        image: Port24ManagedSwitchcatalog2
      },
      {
        f1: "X‑coded M12 Rugged",
        f2: "Dust & Vibrationproof",
        image: Port24ManagedSwitchcatalog3
      },
      {
        f1: "Auto Train-Topology",
        f2: "IEC 61375-Compliant",
        image: Port24ManagedSwitchcatalog4
      },
      {
        f1: "IP68 Armor",
        f2: "Fanless Durability",
        image: Port24ManagedSwitchcatalog5
      },
      {
        f1: "Secure Boot Enabled",
        f2: "IEC 62443 Certified",
        image: Port24ManagedSwitchcatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],
  },

  //Dual Redundant Power Supply
  {
    IsHoriz: true,
    ProductName: (<span>Dual Redundant  <span style={{ color: 'var(--primary-color)' }}> Power Supply</span></span>),
    ProductDescription: (<> Uninterrupted Power for Critical <span style={{ color: 'var(--primary-color)' }}> Industrial Applications</span></>),
    ProductSubText: (<>Designed for high-stakes environments, this rugged power supply delivers constant 24V DC output with automatic dual standby redundancy. It ensures that even in the event of a module failure, your control systems, sensors, and PLCs keep running — without a single hiccup.</>),
    ProductFeatureSvg: DualRedundantPSKeyFeatures,
    ProductFeatureImageMobile: DualRedundantPSKeyFeaturesMobile,
    HomeImage: DualRedundantPSHome,
    MobileHomeImage: DualRedundantPSHome,
    specificationandwarranty: [
      {
        heading: "Proactive Fault Alerts",
        description: "LED and relay indicators ensure fast response during failures.",
        position: "bottom"
      },
      {
        heading: "Rugged Design",
        description: "Built to endure dust, vibration, shock, and thermal extremes.",
        position: "left"
      },
      {
        heading: "Robust Power Architecture",
        description: "Continuously supplies stable, clean 24V power during failure conditions.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Input Voltage:</span> 230V AC Nominal (85–264V AC Range)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Output Voltage:</span> 24V DC Nominal, Tightly Regulated</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Current Options:</span> 5A / 10A / 20A Variants</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Frequency:</span> 47–63 Hz</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Redundancy:</span> Dual Standby Auto Takeover</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Load Sharing:</span> Intelligent, Even Distribution</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Protection:</span> Overload (OLP), Short Circuit (SCP), Over Voltage (OVP), Over Temperature (OTP)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Cooling:</span> Active/Passive (Temperature Based)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Indicators:</span> Power OK, Failure, Standby Active</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Diagnostics:</span> Dry Contact Relays, Modbus (Optional)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span> Optional DIN-Rail</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Enclosure:</span> Rugged Steel, Shock/Vibration Resistant</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temperature Range:</span> -20°C to +70°C</> },
    ],

    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Reliable Power Supply Continuity",
        description: "Keeps operations running despite module failures or AC input drops."
      },
      {
        icon: <Temperature />,
        title: "Extreme Operating Conditions",
        description: "Performs reliably from -20°C to +70°C, even in dusty or vibrating environments."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Intelligent Load Sharing",
        description: "Balances load across modules to prolong lifespan and efficiency."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Proactive Maintenance",
        description: "LED indicators and dry contacts provide failure alerts for predictive servicing."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Ensures uninterrupted power to security infrastructure like CCTV, access control, and alarm systems—protecting assets even during power failures."
      },
      {
        icon: <InnovationIcon />,
        title: "Remote Monitoring Ready",
        description: "Optional Modbus RTU/TCP support for SCADA/BMS systems."
      },

    ],

    // ProductImages: [DualRedundantPSGrey],
    ProductImages: [
      { src: DualRedundantPSGrey, colorCode: 1 },
    ],
    specifications: "This power supply is built to ensure uninterrupted power delivery to mission-critical applications in mobile, industrial, and infrastructure deployments. Its hot standby redundancy, combined with robust protection features and intelligent diagnostics, ensures your systems never falter]even under pressure.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Dual Standby Redundancy',
        desc: 'Two independent power modules with seamless auto-failover ensure zero downtime.',
      },
      {
        side: 'right',
        text: 'Wide Input Voltage Range',
        desc: 'Operates from 85–264V AC, making it globally compatible and fluctuation-resistant.',
      },
      {
        side: 'left',
        text: 'Stable 24V DC Output',
        desc: 'Delivers tightly regulated, clean power for sensitive industrial electronics.',
      },
      {
        side: 'right',
        text: 'Multiple Current Ratings',
        desc: 'Available in 5A, 10A, and 20A variants to suit diverse load demands.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Hot-Swappable Modules',
        desc: 'Replace faulty units on the fly without interrupting system power.',
      },
      {
        side: 'left',
        text: 'Rugged Industrial Design',
        desc: 'Built to withstand shock, vibration, dust, and extreme temperature ranges.',
      },
      {
        side: 'right',
        text: 'Comprehensive Protection',
        desc: 'Includes OLP, SCP, OVP, and OTP for total device and system safety.',
      },
      {
        side: 'left',
        text: 'Smart Diagnostics & Alerts',
        desc: 'LED indicators and dry contact relay outputs enable fast issue detection and SCADA/BMS integration.',
      }
    ],

    ProductCatalog: [
      {
        f1: "Rugged & Compact",
        f2: "Dual Redundant Core",
        image: DualRedundantPScatalog1
      },
      {
        f1: "Wide Voltage Range",
        f2: "Global Input Ready",
        image: DualRedundantPScatalog2
      },
      {
        f1: "Dustproof & Shockproof",
        f2: "Extreme-Use Certified",
        image: DualRedundantPScatalog3
      },
      {
        f1: "Auto Failover",
        f2: "Smart Load Balance",
        image: DualRedundantPScatalog4
      },
      {
        f1: "Hot-Swappable Design",
        f2: "Steel Armor Build",
        image: DualRedundantPScatalog5
      },
      {
        f1: "Secure Boot Enabled",
        f2: "Remote Control Ready",
        image: DualRedundantPScatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],
  },

  //Display Controllers
  {
    IsHoriz: true,
    ProductName: (<span>Display <span style={{ color: 'var(--primary-color)' }}> Controllers</span></span>),
    ProductDescription: (<>Powering Intelligent <span style={{ color: 'var(--primary-color)' }}> Interfaces & Scalable</span> Control</>),
    ProductSubText: (<>Built to perform under the harshest industrial conditions, the Stainless Steel External Display Controller acts as the intelligent interface engine between automation systems and distributed operator displays. It transforms machine data into visually rich, responsive dashboards on external HDMI monitors enabling secure, decentralized control across critical operations. Engineered for hygiene, durability, and seamless integration, it’s the ideal solution for any process where visibility, access control, and reliability are key.</>),
    ProductFeatureSvg: DisplayControllersKeyFeatures,
    ProductFeatureImageMobile: DisplayControllersKeyFeaturesMobile,
    HomeImage: DisplayControllersHome,
    MobileHomeImage: DisplayControllersHome,
    specificationandwarranty: [
      {
        heading: "Made in India Quality",
        description: "Built with pride in India, ensuring dependable quality, easy support, and alignment with indigenous manufacturing initiatives.",
        position: "bottom"
      },
      {
        heading: "Robust Operator Authentication",
        description: "Role-based access ensures users interact only with functions relevant to their role, enhancing both usability and security.",
        position: "left"
      },
      {
        heading: "Mounting & Display Options",
        description: "Supports panel, wall, or VESA mounting. Compatible with a range of HDMI displays—standard or industrial-grade.",
        position: "right"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Video Output:</span> 1 x HDMI (Full HD 1080p)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Processor:</span> Embedded ARM Cortex-A</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>OS:</span> Embedded Linux / Windows IoT</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Memory:</span> Sufficient RAM & Flash for smooth performance</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Interfaces:</span> RJ45, USB, RS485, RS232, CAN, I2C, SPI</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>UI Control:</span> Customizable, role-based access</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Input Voltage:</span> 12–24V DC</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Consumption:</span> Low-power, energy-efficient design</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Enclosure:</span> Stainless steel, IP65-rated</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Mounting:</span> Wall, VESA, DIN rail</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Cooling:</span> Fanless, passive operation</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Operating Temp:</span> -20°C to +60°C</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Form Factor:</span> Compact, industrial-grade</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Certifications:</span> CE, FCC, RoHS, IP65</> }
    ],



    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Smart Visualization Engine",
        description: "Renders real-time dashboards with high clarity and speed, perfect for monitoring complex industrial processes via HDMI."
      },
      {
        icon: <Temperature />,
        title: "Rugged & Hygienic Design",
        description: "Stainless steel IP65 enclosure resists corrosion, dust, and water—ideal for food, pharma, and harsh industrial environments."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Seamless Data Integration",
        description: "Communicates effortlessly with master controllers and legacy systems using Modbus, MQTT, RS485, and other industrial protocols."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Independent Local Control",
        description: "Enables decentralized decision making by providing local displays with critical process data without relying on central systems."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Role-based UI ensures that only authorized users can access specific controls, enhancing operational security and minimizing human error."
      },
      {
        icon: <InnovationIcon />,
        title: "Locally Engineered & Supported",
        description: "Supports indigenous manufacturing, ensures quick support, and aligns with self-reliant industrial growth initiatives."
      },

    ],

    // ProductImages: [DisplayControllersGrey],
    ProductImages: [
      { src: DisplayControllersGrey, colorCode: 1 },
    ],
    specifications: "Our rugged stainless steel Display Controller is built to deliver precision and performance in any industrial environment. Designed for seamless HMI deployment, it offers scalable control, customizable dashboards, and independent access all in a highly durable, corrosion-resistant housing.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Stainless Steel Housing',
        desc: 'IP65-rated enclosure made entirely of stainless steel, offering exceptional protection against dust, water, corrosion, and harsh industrial chemicals.',
      },
      {
        side: 'right',
        text: 'HDMI Display Output',
        desc: 'Delivers high-definition visual output to any HDMI-compatible screen, ideal for flexible and scalable HMI deployment.',
      },
      {
        side: 'left',
        text: 'Built-in UI Engine',
        desc: 'Equipped with a powerful industrial processor to render fluid, real-time dashboards and process visualizations without external PCs.',
      },
      {
        side: 'right',
        text: 'Multi-Protocol I/O',
        desc: 'Supports a wide range of interfaces—RJ45, RS485, RS232, CAN, I2C, SPI.',
      },
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Made in India',
        desc: 'Designed and manufactured in India, supporting local production with globally competitive quality and reliable field support.',
      },
      {
        side: 'left',
        text: 'Flexible Mounting',
        desc: 'Supports VESA, wall, or DIN rail mounting, allowing easy installation in control panels, machinery, or operator stations.',
      },
      {
        side: 'right',
        text: 'Fanless & Compact',
        desc: 'Passive cooling ensures silent, low-maintenance operation even in vibration-prone environments like mobile equipment or factories.',
      },
      {
        side: 'left',
        text: 'Role-Based UI Access',
        desc: 'Create secure, tailored user interfaces with access levels for operators, supervisors, maintenance teams, and administrators.',
      }
    ],

    ProductCatalog: [
      {
        f1: "Steel Body",
        f2: "Slim Design",
        image: DisplayControllerscatalog1
      },
      {
        f1: "12–24V DC",
        f2: "Global Fit",
        image: DisplayControllerscatalog2
      },
      {
        f1: "IP65 Rated",
        f2: "Vibe Safe",
        image: DisplayControllerscatalog3
      },
      {
        f1: "Auto Failover",
        f2: "Smart Share",
        image: DisplayControllerscatalog4
      },
      {
        f1: "Hot-Swappable Design",
        f2: "Steel Armor Build",
        image: DisplayControllerscatalog5
      },
      {
        f1: "OTA Control",
        f2: "Remote Control Ready",
        image: DisplayControllerscatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],
  },

  //Serial Interface Cards
  {
    IsHoriz: true,
    ProductName: (<span>Serial <span style={{ color: 'var(--primary-color)' }}> Interface</span> Cards</span>),
    ProductDescription: (<>Empowering Reliable, Isolated <span style={{ color: 'var(--primary-color)' }}> UART</span> Communication</>),
    ProductSubText: (<>UART is a compact, high-reliability USB to UART converter with built-in digital isolation for safe microcontroller programming and noise-free serial communication. It safeguards both host and target devices from voltage surges and ground loops a must have tool for embedded developers.</>),
    ProductFeatureSvg: SerialInterfaceKeyFeatures,
    ProductFeatureImageMobile: SerialInterfaceKeyFeaturesMobile,
    HomeImage: SerialInterfaceHome,
    MobileHomeImage: SerialInterfaceHome,
    specificationandwarranty: [
      {
        heading: "Auto Flashing",
        description: "Built-in logic toggles EN and IO0 pins for ESP32 — no button pressing required, saving time and avoiding manual errors.",
        position: "bottom"
      },
      {
        heading: "Power Output & Regulation",
        description: "Delivers clean 3.3V power (up to 300 mA) through an onboard LDO regulator, perfect for powering external devices during programming.",
        position: "right"
      },
      {
        heading: "Made in India",
        description: "Designed and manufactured in India, combining performance, quality, and support aligned with local innovation and global standards.",
        position: "left"
      }
    ],
    ProductDetails: [
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Model:</span> UART-ISL-300</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>USB Interface:</span> USB Type-A Plug</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>UART Logic Levels:</span> 3.3V TTL</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Isolation Voltage:</span> 2500 VRMS (Signal Isolation)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Power Output:</span> 3.3V @ 300 mA (Onboard LDO Regulator)</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Supported Devices:</span> ESP32, STM32, Arduino, and other UART-compatible boards</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Programming Support:</span> Automatic BOOT/EN toggling for ESP32 firmware flashing</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Connectors:</span> 6-pin header – TX, RX, 3.3V, GND, EN, IO0</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Protection:</span> ESD Protection for signal lines and power stability</> },
      { details: <><span style={{ color: 'var(--primary-color)', fontWeight: '500' }}>Color:</span> Silver Finish</> }

    ],





    featuresBenefits: [
      {
        icon: <EnergySavingIcon />,
        title: "Power Delivery",
        description: "Provides stable 3.3V output to power your microcontrollers directly."
      },
      {
        icon: <Temperature />,
        title: "Wide Temperature Tolerance",
        description: "Engineered to operate reliably in harsh environments, supporting extended temperature ranges ideal for labs and industrial setups."
      },
      {
        icon: <ConvenienceIcon />,
        title: "Auto Programming",
        description: "ESP32 firmware flashing made hands-free — no button presses."
      },
      {
        icon: <CompatabilitiyIcon />,
        title: "Isolation Protection",
        description: "Safeguards your PC and target hardware with 2500 VRMS isolation."
      },
      {
        icon: <SecurityIcon />,
        title: "Protection",
        description: "Equipped with ESD protection, signal isolation (2500 VRMS), and regulated power to prevent damage from surges, shorts, and static discharge."
      },
      {
        icon: <InnovationIcon />,
        title: "Universal Compatibility",
        description: "Supports all UART-capable devices — from Arduino to STM32."
      },

    ],

    // ProductImages: [SerialInterfaceGrey],
    ProductImages: [
      { src: SerialInterfaceGrey, colorCode: 1 },
    ],
    specifications: "Our compact, isolated USB to UART Converter is built to deliver safe, noise-free serial communication and long-term reliability in any development or testing environment. Designed for seamless integration with microcontrollers like ESP32, STM32, and Arduino, it provides stable power, robust protection, and automatic programming support, all in a compact and rugged design.",
    partners: [{ svg: Rohs }, { svg: Ce }],
    topBranches: [
      {
        side: 'left',
        text: 'Isolated USB to UART Communication',
        desc: 'Ensures complete electrical separation for protection and reliability.',
      },
      {
        side: 'right',
        text: 'ESP32 Auto-Programming Support',
        desc: 'Handles BOOT/EN pin logic automatically no button hassle.',
      },
      {
        side: 'left',
        text: '3.3V Output via Onboard Regulator',
        desc: 'Powers your MCU directly with up to 300 mA output.',
      }
    ],
    bottomBranches: [
      {
        side: 'right',
        text: 'Standard 6-Pin Header',
        desc: 'Includes TX, RX, 3.3V, GND, EN, and IO0 for flexible interfacing.',
      },
      {
        side: 'left',
        text: 'Robust Protection',
        desc: 'Built-in ESD safeguards, LDO regulation, and long-term durability.',
      },
      {
        side: 'right',
        text: 'Universal Microcontroller Compatibility',
        desc: 'Works out of the box with ESP32, STM32, Arduino, and any UART-based development board.',
      },
    ],

    ProductCatalog: [
      {
        f1: "Next-Gen UART",
        f2: "Smart & Sleek",
        image: SerialInterfacecatalog1
      },
      {
        f1: "Global Fit",
        f2: "Wide Voltage",
        image: SerialInterfacecatalog2
      },
      {
        f1: "PWM Safe",
        f2: "Stable Link",
        image: SerialInterfacecatalog3
      },
      {
        f1: "Auto Flash",
        f2: "No Buttons",
        image: SerialInterfacecatalog4
      },
      {
        f1: "Rugged Build",
        f2: "Tough Shell",
        image: SerialInterfacecatalog5
      },
      {
        f1: "OTA Control",
        f2: "Remote Control Ready",
        image: SerialInterfacecatalog6
      }
    ],


    steps: [
      { step: 1, label: "Key Features", key: "features" },
      { step: 2, label: "Benefits", key: "benefits" },
      { step: 3, label: "Product Catalog", key: "catalog" },
      { step: 4, label: "Enquire Now", key: "enquirenow" },
      { step: 5, label: "Specifications", key: "specifications" },
    ],
  },


]













